import { Fragment, Teleport, TransitionGroup, computed, createBlock, createCommentVNode, createElementBlock, createElementVNode, createTextVNode, createVNode, defineComponent, inject, markRaw, mergeProps, nextTick, normalizeClass, normalizeStyle, onBeforeUnmount, onMounted, onUnmounted, openBlock, provide, reactive, ref, renderList, renderSlot, resolveComponent, resolveDirective, resolveDynamicComponent, toDisplayString, toValue, unref, useId, useSlots, vModelSelect, vModelText, vShow, watch, withCtx, withDirectives, withKeys, withModifiers } from "vue";
import { AttributionControl, LngLat, Map as Map$1 } from "maplibre-gl";
import * as uuid from "uuid";
//#region src/components/SmartButton.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$35 = ["disabled"];
var _hoisted_2$27 = ["disabled"];
//#endregion
//#region src/components/SmartButton.vue
var SmartButton_default = /* @__PURE__ */ defineComponent({
	__name: "SmartButton",
	props: {
		boolean: { type: Boolean },
		modelValue: {},
		set: {},
		unset: {}
	},
	emits: ["click", "update:modelValue"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const button_set = ref(null);
		const button_unset = ref(null);
		const emit = __emit;
		let unsetButtonHasFocus = false;
		const dynamicClass = computed(() => {
			return {
				"v-smart-button": true,
				"x-disabled": isDisabled.value,
				"x-selected": isChecked.value
			};
		});
		const isChecked = computed(() => {
			if (props.modelValue === val_set()) return true;
			try {
				if (JSON.stringify(props.modelValue) === JSON.stringify(val_set())) return true;
			} catch (e) {}
			return false;
		});
		const isDisabled = computed(() => {
			return props.modelValue === val_set() && (props.modelValue === val_unset() || val_unset() === void 0);
		});
		function onBlur() {
			window.setTimeout(() => {
				if (unsetButtonHasFocus) {
					if (button_set.value != null) button_set.value.focus();
				} else if (button_unset.value != null) button_unset.value.focus();
			}, 0);
		}
		function onFocus() {
			unsetButtonHasFocus = isChecked.value;
		}
		function onSetClick(evt) {
			emit("update:modelValue", val_set());
			emit("click", evt);
		}
		function onUnsetClick(evt) {
			if (val_unset() !== void 0) emit("update:modelValue", val_unset());
			emit("click", evt);
		}
		function val_set() {
			if (props.boolean) return true;
			return props.set;
		}
		function val_unset() {
			if (props.boolean) return false;
			return props.unset;
		}
		return (_ctx, _cache) => {
			return isChecked.value ? (openBlock(), createElementBlock("button", {
				key: 0,
				ref_key: "button_unset",
				ref: button_unset,
				disabled: isDisabled.value,
				class: normalizeClass(dynamicClass.value),
				onClick: onUnsetClick,
				onFocus,
				onBlur
			}, [renderSlot(_ctx.$slots, "default")], 42, _hoisted_1$35)) : (openBlock(), createElementBlock("button", {
				key: 1,
				ref_key: "button_set",
				ref: button_set,
				disabled: isDisabled.value,
				class: normalizeClass(dynamicClass.value),
				onClick: onSetClick,
				onFocus,
				onBlur
			}, [renderSlot(_ctx.$slots, "default")], 42, _hoisted_2$27));
		};
	}
});
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/typeof.js
function _typeof(o) {
	"@babel/helpers - typeof";
	return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
		return typeof o;
	} : function(o) {
		return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	}, _typeof(o);
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/toPrimitive.js
function toPrimitive(t, r) {
	if ("object" != _typeof(t) || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != _typeof(i)) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/toPropertyKey.js
function toPropertyKey(t) {
	var i = toPrimitive(t, "string");
	return "symbol" == _typeof(i) ? i : i + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/defineProperty.js
function _defineProperty(e, r, t) {
	return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
		value: t,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[r] = t, e;
}
//#endregion
//#region src/composables/useOnElementResize.ts
function useOnElementResize(target, callback) {
	const observer = new ResizeObserver((entries) => callback(entries[0]));
	onMounted(() => {
		const el = unref(target);
		if (el != null) observer.observe(el);
	});
	onUnmounted(() => {
		observer.disconnect();
	});
}
//#endregion
//#region src/components/maplibre/MapLibreMap.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$34 = ["data-tooltip"];
var _hoisted_2$26 = {
	key: 0,
	class: "v-ml-map__no-layers-info"
};
var _hoisted_3$21 = { class: "v-ml-map__map-config-view" };
var defaultGlyphsUrl = "https://demotiles.maplibre.org/font/{fontstack}/{range}.pbf";
/**
* Apply a new MapLibre style. Called imperatively by MapView whenever
* updateMap() produces a genuinely new style object. Using an explicit
* method call instead of a prop watcher avoids Vue's reactive proxy
* wrapping, which causes reference equality checks to always fail and
* results in spurious m.setStyle() calls on every pan/zoom/tile event.
*/
var MapLibreMap_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	__name: "MapLibreMap",
	props: {
		style: { default: () => ({}) },
		mapModules: { default: () => Array() },
		options: { default: () => ({}) },
		showMapConfig: {
			type: Boolean,
			default: () => false
		}
	},
	emits: [
		"featureClick",
		"featureIn",
		"featureOut",
		"update:dataLoadingOut",
		"update:stateOut",
		"update:showMapConfig"
	],
	setup(__props, { expose: __expose, emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const _showMapConfig = computed({
			get: () => props.showMapConfig,
			set(newval) {
				emit("update:showMapConfig", newval);
			}
		});
		const dynamicClass = computed(() => {
			return {
				"v-maplibre-map": true,
				"v-maplibre-map--hover": prevHoverFeature.value != null
			};
		});
		const noVisibleLayers = computed(() => {
			let noVisibleLayers = true;
			for (const layer of props.style?.layers || []) if (!layer.layout?.visibility || layer.layout.visibility == "visible") noVisibleLayers = false;
			return noVisibleLayers;
		});
		const mapContainerRef = ref(null);
		const mapModules = Array();
		const loadedSymbolImages = /* @__PURE__ */ new Set();
		const tooltip = ref("");
		let currentlyLoadingSources = /* @__PURE__ */ new Set();
		const prevHoverFeature = ref(null);
		let prevHoverFeatureStringified = "";
		let resizeTimeout = null;
		function debouncedResize() {
			if (resizeTimeout !== null) clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(() => {
				onResize();
				resizeTimeout = null;
			}, 16);
		}
		useOnElementResize(mapContainerRef, debouncedResize);
		const mapRef = ref();
		const map = new Promise((resolve) => {
			watch(() => mapRef.value, (newValue) => {
				if (newValue instanceof Map$1) resolve(newValue);
			}, { immediate: true });
		});
		let initialExtentSet = false;
		let currentExtent = [];
		async function applyStyle(newStyle) {
			const m = await map;
			if (newStyle.initialExtent && !initialExtentSet) {
				m.fitBounds(newStyle.initialExtent, {
					animate: false,
					padding: 0
				}, { originalEvent: { type: "programmatic" } });
				initialExtentSet = true;
			}
			const sources = newStyle.sources || {};
			const layers = newStyle.layers || [];
			const missingSourceLayer = layers.filter((layer) => {
				return (sources?.[layer?.source])?.type === "vector" && !layer?.["source-layer"];
			});
			if (missingSourceLayer.length > 0) {
				const layerIds = missingSourceLayer.map((l) => l?.id).join(", ");
				alert(`Achtung: ${missingSourceLayer.length} Layer ohne "source-layer" (Vektor-Quelle): ${layerIds}`);
			}
			loadedSymbolImages.clear();
			m.setStyle({
				version: 8,
				sources,
				layers,
				glyphs: newStyle.glyphs || defaultGlyphsUrl
			});
			m.once("styledata", () => {
				for (const module of mapModules) module.reapplyStyleOverrides();
			});
		}
		async function emitState() {
			const m = await map;
			const zoom = m.getZoom();
			const lat_rad = m.getCenter().lat * Math.PI / 180;
			const res = 40075016.686 * Math.cos(lat_rad) / (512 * Math.pow(2, zoom));
			emit("update:stateOut", {
				extent: m.getBounds().toArray().flat(),
				center: m.getCenter().toArray().flat(),
				zoom,
				resolution: res
			});
		}
		/**
		* Returns the map module that owns the given feature, based on the
		* `moduleConfig.uuid + "_"` prefix that is applied to all layer ids
		* when a module's style is registered. Returns `undefined` if no
		* module claims the feature.
		*/
		function findMapModuleForFeature(feature) {
			if (!feature?.layer?.id) return;
			return mapModules.find((m) => feature.layer.id.startsWith(m.uuid + "_"));
		}
		async function fitBounds(bounds, options) {
			(await map).fitBounds([[bounds[0], bounds[1]], [bounds[2], bounds[3]]], {
				animate: options?.animate || false,
				padding: options?.padding || 0
			}, { originalEvent: { type: "programmatic" } });
		}
		async function flyTo(coordinates, zoom) {
			const m = await map;
			const c = new LngLat(coordinates[0], coordinates[1]);
			m.flyTo({
				center: c,
				zoom,
				duration: 1e3
			}, { originalEvent: { type: "programmatic" } });
		}
		async function getSize() {
			const container = (await map).getContainer();
			return {
				width: container.clientWidth,
				height: container.clientHeight
			};
		}
		async function saveMapImage() {
			const url = (await map).getCanvas().toDataURL("image/png");
			const a = document.createElement("a");
			a.href = url;
			a.download = "map.png";
			a.click();
		}
		function onData(e) {
			if (e.dataType !== "source") return;
			currentlyLoadingSources.delete(e.sourceId);
			emit("update:dataLoadingOut", currentlyLoadingSources.size !== 0);
		}
		function onDataAbort(e) {
			if (e.dataType !== "source") return;
			currentlyLoadingSources.delete(e.sourceId);
			emit("update:dataLoadingOut", currentlyLoadingSources.size !== 0);
		}
		function onDataLoading(e) {
			if (e.dataType !== "source") return;
			currentlyLoadingSources.add(e.sourceId);
			emit("update:dataLoadingOut", currentlyLoadingSources.size !== 0);
		}
		/**
		* Handles MapLibre "error" events. When a source/tile fails to load (e.g. a
		* 502 from the proxy), MapLibre fires an "error" event but never fires the
		* matching "data" or "dataabort" event. Without this handler, the failed
		* source would remain in `currentlyLoadingSources` forever, leaving the
		* loading indicator stuck on and making the map appear unusable.
		*
		* We only act on errors that carry a `sourceId` (tile/source load failures);
		* other errors are left untouched.
		*/
		function onError(e) {
			const sourceId = e?.error?.sourceId;
			if (sourceId && currentlyLoadingSources.has(sourceId)) {
				currentlyLoadingSources.delete(sourceId);
				emit("update:dataLoadingOut", currentlyLoadingSources.size !== 0);
			}
		}
		async function onMapClick(e) {
			const m = await map;
			const b = m.getBounds();
			const container = m.getContainer();
			const mapViewport = {
				bounds: {
					west: b.getWest(),
					south: b.getSouth(),
					east: b.getEast(),
					north: b.getNorth()
				},
				width: container.clientWidth,
				height: container.clientHeight
			};
			const lngLat = {
				lng: e.lngLat.lng,
				lat: e.lngLat.lat
			};
			let featuresUnderMouse = Array();
			try {
				featuresUnderMouse = m.queryRenderedFeatures(e.point);
			} catch (e) {}
			let topFeature = null;
			for (let feature of featuresUnderMouse) {
				const owningModule = findMapModuleForFeature(feature);
				if (!owningModule || owningModule.ignorePointerEvents) continue;
				topFeature = feature;
				break;
			}
			if (topFeature) {
				const topFeatureClone = JSON.parse(JSON.stringify(topFeature));
				for (const key in topFeatureClone.properties) try {
					topFeatureClone.properties[key] = JSON.parse(topFeatureClone.properties[key]);
				} catch (e) {}
				topFeature = topFeatureClone;
			}
			const event = {
				feature: topFeature,
				button: e.originalEvent?.button,
				pixelPoint: {
					x: e.point.x,
					y: e.point.y
				},
				lngLat,
				mapViewport
			};
			const owningModule = findMapModuleForFeature(topFeature);
			if (owningModule) owningModule.onFeatureClick(event);
			for (const mapModule of mapModules) {
				if (mapModule == owningModule) continue;
				mapModule.onOutsideClick(event);
			}
		}
		async function onMapMouseMove(e) {
			const m = await map;
			const lngLatForHook = {
				lng: e.lngLat.lng,
				lat: e.lngLat.lat
			};
			for (const mapModule of mapModules) mapModule.onMapMouseMove(lngLatForHook);
			let featuresUnderMouse = Array();
			try {
				featuresUnderMouse = m.queryRenderedFeatures(e.point);
			} catch (e) {}
			let topFeature = null;
			for (let feature of featuresUnderMouse) {
				const owningModule = findMapModuleForFeature(feature);
				if (!owningModule || owningModule.ignorePointerEvents) continue;
				topFeature = feature;
				break;
			}
			const currentHoverFeatureStringified = JSON.stringify(topFeature);
			if (currentHoverFeatureStringified == prevHoverFeatureStringified) return;
			if (prevHoverFeature.value) {
				const event = { feature: prevHoverFeature.value };
				for (const controller of mapModules) if (controller.onFeatureOut) controller.onFeatureOut(event);
			}
			tooltip.value = "";
			prevHoverFeature.value = topFeature;
			prevHoverFeatureStringified = currentHoverFeatureStringified;
			if (topFeature) {
				const topFeatureClone = JSON.parse(prevHoverFeatureStringified);
				for (const key in topFeatureClone.properties) try {
					topFeatureClone.properties[key] = JSON.parse(topFeatureClone.properties[key]);
				} catch (e) {}
				const event = { feature: topFeatureClone };
				const owningModule = findMapModuleForFeature(topFeature);
				if (owningModule) {
					owningModule.onFeatureIn(event);
					if (owningModule.tooltipFunc) {
						const tt = owningModule.tooltipFunc(topFeatureClone);
						tooltip.value = tt || "";
					}
				}
			}
		}
		async function onMapMoveEnd(e) {
			const m = await map;
			if (e.originalEvent != void 0) currentExtent = m.getBounds().toArray().flat();
			emitState();
		}
		async function onMapLoad() {
			const m = await map;
			setTimeout(() => {
				currentExtent = m.getBounds().toArray().flat();
			}, 100);
		}
		async function onResize() {
			const m = await map;
			if (currentExtent.length == 4) {
				const preservedExtent = [...currentExtent];
				m.resize();
				requestAnimationFrame(() => {
					m.fitBounds(preservedExtent, {
						animate: true,
						padding: 0,
						duration: 200
					});
					requestAnimationFrame(() => {
						emitState();
					});
				});
			} else {
				m.resize();
				requestAnimationFrame(() => {
					currentExtent = m.getBounds().toArray().flat();
					emitState();
				});
			}
		}
		async function setFilter(layerId, filter) {
			const m = await map;
			try {
				if (!m.getLayer(layerId)) return;
				m.setFilter(layerId, filter);
			} catch (e) {}
		}
		async function setLayoutProperty(layerId, name, value) {
			const m = await map;
			try {
				m.setLayoutProperty(layerId, name, value);
			} catch (e) {}
		}
		async function setPaintProperty(layerId, name, value) {
			const m = await map;
			try {
				m.setPaintProperty(layerId, name, value);
			} catch (e) {}
		}
		function setTooltip(tt) {
			tooltip.value = tt;
		}
		onMounted(() => {
			if (!mapContainerRef.value) return;
			const m = new Map$1({
				container: mapContainerRef.value,
				style: {
					version: 8,
					sources: {},
					layers: [],
					glyphs: defaultGlyphsUrl
				},
				doubleClickZoom: false,
				dragRotate: props.options.allowRotate ?? false,
				touchZoomRotate: true,
				attributionControl: false
			});
			const attribution = new AttributionControl({ compact: true });
			m.addControl(attribution, "bottom-left");
			if (!props.options.allowRotate) m.touchZoomRotate.disableRotation();
			m.touchPitch.disable();
			m.on("click", onMapClick);
			m.on("contextmenu", onMapClick);
			m.on("data", onData);
			m.on("dataabort", onDataAbort);
			m.on("dataloading", onDataLoading);
			m.on("error", onError);
			m.on("load", onMapLoad);
			m.on("mousemove", onMapMouseMove);
			m.on("moveend", onMapMoveEnd);
			m.on("styleimagemissing", async (e) => {
				const imageUrl = e.id;
				if (loadedSymbolImages.has(imageUrl)) return;
				loadedSymbolImages.add(imageUrl);
				try {
					const res = await m.loadImage(imageUrl);
					if (res) {
						if (!m.hasImage(imageUrl)) m.addImage(imageUrl, res.data);
					} else {
						console.warn(`[MapLibreMap] Failed to load icon image: ${imageUrl}`);
						loadedSymbolImages.delete(imageUrl);
					}
					console.log("Loading style image " + imageUrl);
				} catch (err) {
					console.warn(`[MapLibreMap] Error loading icon image: ${imageUrl}`, err);
					loadedSymbolImages.delete(imageUrl);
				}
			});
			mapRef.value = m;
		});
		onUnmounted(() => {
			map.then((m) => m.remove());
		});
		emit("update:dataLoadingOut", false);
		watch(() => props.mapModules, async (newMapModules) => {
			mapModules.length = 0;
			const actions = {
				fitBounds,
				flyTo,
				getSize,
				setTooltip,
				setLayoutProperty,
				setPaintProperty,
				setFilter
			};
			for (const module of newMapModules) {
				mapModules.push(module);
				module.map = actions;
			}
		}, { immediate: true });
		__expose({
			fitBounds,
			saveMapImage,
			applyStyle
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(dynamicClass.value) }, [
				createElementVNode("div", {
					ref_key: "mapContainerRef",
					ref: mapContainerRef,
					class: "v-ml-map__container",
					"data-tooltip": tooltip.value,
					role: "application",
					"aria-label": "Interaktive Karte"
				}, null, 8, _hoisted_1$34),
				noVisibleLayers.value ? (openBlock(), createElementBlock("div", _hoisted_2$26, " Die Karte enthält keine sichtbaren Ebenen. ")) : createCommentVNode("", true),
				props.showMapConfig ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [createElementVNode("div", _hoisted_3$21, [createElementVNode("pre", null, toDisplayString(JSON.stringify(props.style, null, 2)) + " ", 1)]), createVNode(SmartButton_default, {
					class: "v-ml-map__map-config-display-toggle",
					modelValue: _showMapConfig.value,
					"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _showMapConfig.value = $event),
					"data-tooltip": "Kartenkonfigurationsansicht schließen"
				}, {
					default: withCtx(() => [..._cache[1] || (_cache[1] = [createTextVNode("x", -1)])]),
					_: 1
				}, 8, ["modelValue"])], 64)) : createCommentVNode("", true)
			], 2);
		};
	}
});
//#endregion
//#region \0plugin-vue:export-helper
var _plugin_vue_export_helper_default = (sfc, props) => {
	const target = sfc.__vccOpts || sfc;
	for (const [key, val] of props) target[key] = val;
	return target;
};
//#endregion
//#region src/components/maplibre/MapLibreMap.vue
var MapLibreMap_default = /* @__PURE__ */ _plugin_vue_export_helper_default(MapLibreMap_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-88096d9f"]]);
//#endregion
//#region src/components/maplibre/AbstractMapModule.ts
var AbstractMapModule = class {
	/** The current opacity value of this module's layers (0–1). */
	get opacity() {
		return this.reactiveData.opacity ?? 1;
	}
	/**
	* Updates the opacity of all MapLibre layers belonging to this module
	* by setting the appropriate paint property on each live layer.
	* The opacity value is clamped to [0, 1].
	*/
	set opacity(newVal) {
		const clamped = Math.max(0, Math.min(1, newVal));
		this.reactiveData.opacity = clamped;
		for (const layer of this.reactiveData.activeStyle?.layers || []) {
			if (!layer.id.startsWith(this.uuid + "_")) continue;
			if (this.map) this.map.setLayoutProperty(layer.id, "visibility", clamped > 0 ? "visible" : "none");
			const paintProp = this.getOpacityPaintProperty(layer.type);
			if (paintProp) {
				const layerOpacity = layer.paint?.[paintProp] ?? 1;
				this.map?.setPaintProperty(layer.id, paintProp, clamped * layerOpacity);
			}
		}
	}
	get visible() {
		return this.opacity > 0;
	}
	set visible(newVal) {
		this.opacity = newVal ? this.moduleConfig.opacity || 1 : 0;
	}
	getLegendData() {
		return null;
	}
	constructor(config) {
		_defineProperty(this, "uuid", uuid.v4().toString());
		_defineProperty(this, "ignorePointerEvents", false);
		_defineProperty(this, "reactiveData", reactive({
			visible: true,
			opacity: 1
		}));
		_defineProperty(this, "map", void 0);
		this.moduleConfig = config;
		let opacity = config.opacity;
		if (!opacity && opacity !== 0) opacity = 1;
		this.reactiveData.opacity = opacity;
		this.ignorePointerEvents = this.moduleConfig.ignorePointerEvents || false;
	}
	/**
	* Lifecycle method called by MapView after the module is constructed and
	* updateMap callback is assigned. Override in subclasses to perform
	* initialization that requires the updateMap callback to be available.
	* 
	* The base implementation applies the initial style from moduleConfig if present.
	*/
	init() {
		if (this.moduleConfig.style) this.setStyle(this.moduleConfig.style);
	}
	/** Called when the user clicks a feature belonging to this module. Override to handle. */
	onFeatureClick(e) {}
	/** Called then the user clicks on a point that is *not* a feature of this module */
	onOutsideClick(e) {}
	/** Called when the cursor enters a feature belonging to this module. */
	onFeatureIn(e) {}
	/** Called when the cursor leaves a feature belonging to this module. */
	onFeatureOut(e) {}
	/**
	* Called on every map mouse-move event with the current WGS84 cursor position.
	* Override to react to per-pixel coordinate changes (e.g. raster value queries).
	* Keep implementations lightweight — this fires on every move pixel.
	*/
	onMapMouseMove(lngLat) {}
	/**
	* Returns all layers whose id starts with `prefix`.
	* Used to locate hover/select highlight layers by their module-scoped prefix.
	*/
	findLayersWithPrefix(prefix) {
		const result = [];
		for (const layer of this.reactiveData.activeStyle?.layers || []) if (prefix ? layer.id.startsWith(prefix) : true) result.push(layer);
		return result;
	}
	/**
	* The method prepareStyle() takes the map module's style object and applies some
	* modifications before it is inserted to the actual MapLibre map configuration:
	* 
	* - Prefix all source and layer IDs in a style with the module's UUID to avoid
	*   naming conflicts between different map modules.
	* 
	* - Adjust each layer's opacity according to the map-module-level opacity value.
	*/
	prepareStyle(style) {
		const preparedStyle = JSON.parse(JSON.stringify(style));
		const newSources = {};
		for (const sourceId in preparedStyle.sources) newSources[this.uuid + "_" + sourceId] = preparedStyle.sources[sourceId];
		preparedStyle.sources = newSources;
		for (const layer of preparedStyle.layers || []) {
			layer.id = this.uuid + "_" + layer.id;
			layer.source = this.uuid + "_" + layer.source;
		}
		return preparedStyle;
	}
	/**
	* Returns the MapLibre paint property name for opacity based on layer type.
	*/
	getOpacityPaintProperty(layerType) {
		switch (layerType) {
			case "circle": return "circle-opacity";
			case "fill": return "fill-opacity";
			case "line": return "line-opacity";
			case "raster": return "raster-opacity";
			default: return null;
		}
	}
	setAllLayersVisibility(visible) {
		this.visible = visible;
	}
	setStyle(style) {
		this.reactiveData.activeStyle = markRaw(this.prepareStyle(style));
	}
	/**
	* Called by MapLibreMap after every `m.setStyle()` completes (on the `styledata`
	* event). Override in subclasses to reapply any layout overrides that were wiped
	* by the full style reload — e.g. hover/select filter expressions.   
	*/
	reapplyStyleOverrides() {}
	tooltipFunc(feature) {
		return null;
	}
};
//#endregion
//#region src/components/ViewStack/ViewStack.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$33 = { class: "v-view-stack" };
var _hoisted_2$25 = { class: "v-view-stack__item__header" };
var _hoisted_3$20 = [
	"data-tooltip",
	"disabled",
	"onClick",
	"innerHTML"
];
var _hoisted_4$16 = ["data-tooltip", "onClick"];
var _hoisted_5$1 = ["inert"];
//#endregion
//#region src/components/ViewStack/ViewStack.vue
var ViewStack_default = /* @__PURE__ */ defineComponent({
	__name: "ViewStack",
	props: { controller: {} },
	setup(__props) {
		const props = __props;
		function extendedProps(item) {
			return {
				...item.props,
				viewStackItem: item
			};
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$33, [createVNode(TransitionGroup, {
				name: "view-stack-slide",
				tag: "ul"
			}, {
				default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(props.controller.items, (item, index) => {
					return openBlock(), createElementBlock("li", {
						key: item.id,
						class: normalizeClass({
							"v-view-stack__item": true,
							"x-top": index === props.controller.items.length - 1,
							"x-covered": index < props.controller.items.length - 1
						}),
						style: normalizeStyle(`top:${index * 30}px;left:${index * 0}px;`)
					}, [createElementVNode("header", _hoisted_2$25, [createElementVNode("h2", null, [createElementVNode("button", {
						"data-tooltip": `Zurück zum Panel '${item.title}'`,
						disabled: item == props.controller.topItem,
						onClick: ($event) => index < props.controller.items.length - 1 && __props.controller.popToIndex(index),
						innerHTML: item.title
					}, null, 8, _hoisted_3$20)]), index > 0 && index == props.controller.items.length - 1 ? (openBlock(), createElementBlock("button", {
						key: 0,
						"data-tooltip": `Panel '${item.title}' schließen`,
						class: "v-atlas-stack-back-button",
						onClick: ($event) => __props.controller.removeItemAtIndex(index)
					}, [..._cache[0] || (_cache[0] = [createElementVNode("span", null, "Zurück", -1)])], 8, _hoisted_4$16)) : createCommentVNode("", true)]), createElementVNode("div", {
						class: "v-view-stack__item-content",
						inert: index < props.controller.items.length - 1
					}, [(openBlock(), createBlock(resolveDynamicComponent(item.componentName), mergeProps({ ref_for: true }, extendedProps(item)), null, 16))], 8, _hoisted_5$1)], 6);
				}), 128))]),
				_: 1
			})]);
		};
	}
});
//#endregion
//#region src/components/ViewStack/ViewStackController.ts
var ViewStackController = class {
	constructor() {
		_defineProperty(this, "items", reactive([]));
	}
	addItem(item) {
		const existingItemIndex = this.items.findIndex((i) => i.role === item.role);
		if (existingItemIndex !== -1) {
			this.popToIndex(existingItemIndex);
			this.items.splice(existingItemIndex, 1);
		}
		item.props.viewStackController = this;
		this.items.push(item);
	}
	popItem() {
		if (this.items.length > 1) this.items.pop();
	}
	/** Pop all items above the given index so that `items[index]` becomes the top item. */
	popToIndex(index) {
		if (index >= 0 && index < this.items.length - 1) this.items.splice(index + 1);
	}
	removeItemAtIndex(index) {
		if (index >= 0 && index < this.items.length) this.items.splice(index, 1);
	}
	get topItem() {
		if (this.items.length > 0) return this.items[this.items.length - 1];
		return null;
	}
};
//#endregion
//#region src/components/contextMenu/contextMenu.ts
/** Reactive singleton that controls the global context menu state. */
var contextMenu = reactive({
	visible: false,
	x: 0,
	y: 0,
	items: [],
	/** Show the context menu at the given pixel coordinates with the given items. */
	open(items, x, y) {
		this.items = items;
		this.x = x;
		this.y = y;
		this.visible = true;
	},
	/** Hide the context menu and clear its items. */
	close() {
		this.visible = false;
		this.items = [];
	}
});
//#endregion
//#region src/components/contextMenu/ContextMenu.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$32 = { class: "v-context-menu__list" };
var _hoisted_2$24 = ["onClick"];
//#endregion
//#region src/components/contextMenu/ContextMenu.vue
var ContextMenu_default = /* @__PURE__ */ defineComponent({
	__name: "ContextMenu",
	setup(__props) {
		const menuRef = ref(null);
		function onItemClick(item) {
			item.action();
			contextMenu.close();
		}
		function onDocumentMouseDown(e) {
			if (contextMenu.visible && menuRef.value && !menuRef.value.contains(e.target)) contextMenu.close();
		}
		onMounted(() => {
			document.addEventListener("mousedown", onDocumentMouseDown);
		});
		onUnmounted(() => {
			document.removeEventListener("mousedown", onDocumentMouseDown);
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(Teleport, { to: "body" }, [unref(contextMenu).visible ? (openBlock(), createElementBlock("div", {
				key: 0,
				ref_key: "menuRef",
				ref: menuRef,
				class: "v-context-menu",
				style: normalizeStyle({
					left: unref(contextMenu).x + "px",
					top: unref(contextMenu).y + "px"
				})
			}, [createElementVNode("ul", _hoisted_1$32, [(openBlock(true), createElementBlock(Fragment, null, renderList(unref(contextMenu).items, (item, index) => {
				return openBlock(), createElementBlock("li", {
					key: index,
					class: "v-context-menu__item",
					onClick: ($event) => onItemClick(item)
				}, toDisplayString(item.label), 9, _hoisted_2$24);
			}), 128))])], 4)) : createCommentVNode("", true)]);
		};
	}
});
//#endregion
//#region src/components/legend/SimpleLegendItemRenderer.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$31 = { class: "v-legend__simple-legend-item" };
var _hoisted_2$23 = { class: "v-legend__simple-legend-item__symbol-wrapper" };
var _hoisted_3$19 = ["opacity"];
//#endregion
//#region src/components/legend/SimpleLegendItemRenderer.vue
var SimpleLegendItemRenderer_default = /* @__PURE__ */ defineComponent({
	__name: "SimpleLegendItemRenderer",
	props: { item: {} },
	setup(__props) {
		function getItemLabel(item) {
			return item.label;
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$31, [createElementVNode("div", _hoisted_2$23, [(openBlock(), createElementBlock("svg", null, [createElementVNode("rect", {
				style: normalizeStyle(__props.item.style),
				opacity: __props.item.opacity
			}, null, 12, _hoisted_3$19)]))]), createElementVNode("div", null, toDisplayString(getItemLabel(__props.item)), 1)]);
		};
	}
});
//#endregion
//#region src/components/SvgColorGradient.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$30 = {
	class: "v-svg-color-gradient__svg",
	preserveAspectRatio: "none",
	xmlns: "http://www.w3.org/2000/svg"
};
var _hoisted_2$22 = [
	"id",
	"x1",
	"y1",
	"x2",
	"y2"
];
var _hoisted_3$18 = ["offset", "stop-color"];
var _hoisted_4$15 = ["fill"];
//#endregion
//#region src/components/SvgColorGradient.vue
var SvgColorGradient_default = /* @__PURE__ */ defineComponent({
	__name: "SvgColorGradient",
	props: { config: {} },
	setup(__props) {
		const props = __props;
		const fallbackId = useId();
		const gradientId = computed(() => `svg-gradient-${fallbackId}`);
		const isVertical = computed(() => props.config.orientation === "vertical");
		const verticalClass = computed(() => ({ "v-svg-color-gradient--vertical": isVertical.value }));
		const x1 = computed(() => isVertical.value ? "0" : "0");
		const y1 = computed(() => isVertical.value ? "0" : "0");
		const x2 = computed(() => isVertical.value ? "0" : "1");
		const y2 = computed(() => isVertical.value ? "1" : "0");
		const gradientStops = computed(() => {
			const colors = props.config.colors;
			const stops = props.config.stops;
			const count = colors.length;
			if (count === 0) return [];
			return colors.map((color, index) => {
				let offset;
				if (stops && stops.length > index && stops[index] !== void 0) offset = `${Math.max(0, Math.min(1, stops[index]))}`;
				else if (count === 1) offset = "0";
				else offset = `${index / (count - 1)}`;
				return {
					offset,
					color
				};
			});
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["v-svg-color-gradient", verticalClass.value]) }, [(openBlock(), createElementBlock("svg", _hoisted_1$30, [createElementVNode("defs", null, [createElementVNode("linearGradient", {
				id: gradientId.value,
				x1: x1.value,
				y1: y1.value,
				x2: x2.value,
				y2: y2.value
			}, [(openBlock(true), createElementBlock(Fragment, null, renderList(gradientStops.value, (stop, index) => {
				return openBlock(), createElementBlock("stop", {
					key: index,
					offset: stop.offset,
					"stop-color": stop.color
				}, null, 8, _hoisted_3$18);
			}), 128))], 8, _hoisted_2$22)]), createElementVNode("rect", {
				x: "0",
				y: "0",
				width: "100%",
				height: "100%",
				fill: `url(#${gradientId.value})`
			}, null, 8, _hoisted_4$15)]))], 2);
		};
	}
});
//#endregion
//#region src/components/legend/MultiStepGradientLegendItemRenderer.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$29 = { class: "v-legend__multi-step-gradient-legend-item" };
var _hoisted_2$21 = {
	key: 0,
	class: "v-legend__multi-step-gradient-legend-item__range"
};
var _hoisted_3$17 = { class: "v-legend__multi-step-gradient-legend-item__range-min" };
var _hoisted_4$14 = { class: "v-legend__multi-step-gradient-legend-item__range-max" };
//#endregion
//#region src/components/legend/MultiStepGradientLegendItemRenderer.vue
var MultiStepGradientLegendItemRenderer_default = /* @__PURE__ */ defineComponent({
	__name: "MultiStepGradientLegendItemRenderer",
	props: { item: {} },
	setup(__props) {
		const props = __props;
		/**
		* Builds the gradient config for the SvgColorGradient component from the
		* data-driven gradient stops of the legend item. The renderer does NOT
		* hardcode any colors — everything comes from `item.gradientStops`.
		*/
		const gradientConfig = computed(() => {
			const stops = props.item.gradientStops ?? [];
			return {
				colors: stops.map((stop) => stop.color),
				stops: stops.map((stop) => stop.offset),
				orientation: "horizontal"
			};
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$29, [createElementVNode("div", {
				class: "v-legend__multi-step-gradient-legend-item__bar",
				style: normalizeStyle({ opacity: __props.item.opacity })
			}, [createVNode(SvgColorGradient_default, { config: gradientConfig.value }, null, 8, ["config"])], 4), __props.item.minLabel || __props.item.maxLabel ? (openBlock(), createElementBlock("div", _hoisted_2$21, [createElementVNode("span", _hoisted_3$17, toDisplayString(__props.item.minLabel), 1), createElementVNode("span", _hoisted_4$14, toDisplayString(__props.item.maxLabel), 1)])) : createCommentVNode("", true)]);
		};
	}
});
//#endregion
//#region src/components/legend/ImageLegendItemRenderer.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$28 = { class: "v-legend__image-legend-item" };
var _hoisted_2$20 = ["src", "alt"];
var _hoisted_3$16 = ["innerHTML"];
//#endregion
//#region src/components/legend/ImageLegendItemRenderer.vue
var ImageLegendItemRenderer_default = /* @__PURE__ */ defineComponent({
	__name: "ImageLegendItemRenderer",
	props: { item: {} },
	setup(__props) {
		function getItemLabel(item) {
			return item.label;
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$28, [createElementVNode("img", {
				src: __props.item.imageUrl,
				alt: __props.item.label ?? "",
				style: normalizeStyle({ opacity: __props.item.opacity })
			}, null, 12, _hoisted_2$20), getItemLabel(__props.item) ? (openBlock(), createElementBlock("div", {
				key: 0,
				innerHTML: getItemLabel(__props.item)
			}, null, 8, _hoisted_3$16)) : createCommentVNode("", true)]);
		};
	}
});
//#endregion
//#region src/components/legend/Legend.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$27 = { class: "v-legend" };
var _hoisted_2$19 = { class: "v-legend__group" };
var _hoisted_3$15 = {
	key: 0,
	class: "v-legend__group__items-wrapper"
};
var _hoisted_4$13 = { key: 0 };
//#endregion
//#region src/components/legend/Legend.vue
var Legend_default = /* @__PURE__ */ defineComponent({
	__name: "Legend",
	props: {
		data: {},
		highlight: {}
	},
	setup(__props) {
		const itemRenderers = {
			SimpleLegendItem: SimpleLegendItemRenderer_default,
			MultiStepGradientLegendItem: MultiStepGradientLegendItemRenderer_default,
			ImageLegendItem: ImageLegendItemRenderer_default
		};
		function getItemClass(item) {
			return { "v-legend__item": true };
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$27, [__props.data?.groups ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(__props.data.groups, (group) => {
				return openBlock(), createElementBlock("div", _hoisted_2$19, [createElementVNode("h4", null, toDisplayString(group.label), 1), group && group.items && group.items instanceof Array ? (openBlock(), createElementBlock("div", _hoisted_3$15, [(openBlock(true), createElementBlock(Fragment, null, renderList(group.items, (item) => {
					return openBlock(), createElementBlock("button", {
						class: normalizeClass(getItemClass(item)),
						disabled: "true"
					}, [(openBlock(), createBlock(resolveDynamicComponent(itemRenderers[item.type]), { item }, null, 8, ["item"]))], 2);
				}), 256)), group.items.length == 0 ? (openBlock(), createElementBlock("div", _hoisted_4$13, " Keine Einträge ")) : createCommentVNode("", true)])) : createCommentVNode("", true)]);
			}), 256)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [createTextVNode(" Keine Legendeninformationen vorhanden ")], 64))]);
		};
	}
});
//#endregion
//#region src/components/collapsible/Collapsible.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$26 = {
	key: 0,
	class: "v-collapsible__body"
};
//#endregion
//#region src/components/collapsible/Collapsible.vue
var Collapsible_default = /* @__PURE__ */ defineComponent({
	__name: "Collapsible",
	props: {
		header: { default: "Aufklappbereich" },
		collapsed: {
			type: Boolean,
			default: true
		},
		toggleGroupId: {}
	},
	setup(__props) {
		const props = __props;
		const collapsed = ref(props.collapsed);
		const dynamicClass = computed(() => {
			return {
				"v-collapsible": true,
				"v-collapsible--collapsed": collapsed.value,
				"v-collapsible--uncollapsed": !collapsed.value
			};
		});
		function toggle(evt) {
			collapsed.value = !collapsed.value;
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(dynamicClass.value) }, [createElementVNode("button", {
				class: "v-collapsible__header",
				onClick: toggle
			}, [renderSlot(_ctx.$slots, "header", { toggle }, () => [createTextVNode(toDisplayString(props.header), 1)])]), !collapsed.value ? (openBlock(), createElementBlock("div", _hoisted_1$26, [renderSlot(_ctx.$slots, "default", {}, () => [_cache[0] || (_cache[0] = createTextVNode(" [ Text im Aufklappbereich ] ", -1))])])) : createCommentVNode("", true)], 2);
		};
	}
});
//#endregion
//#region src/SelectMode.ts
var SelectMode = /* @__PURE__ */ function(SelectMode) {
	SelectMode["None"] = "none";
	SelectMode["Single"] = "single";
	SelectMode["SingleArray"] = "single-array";
	SelectMode["Multi"] = "multi";
	return SelectMode;
}({});
//#endregion
//#region src/util/miscUtils.ts
function debounce(func, delay_ms) {
	let timeout = -1;
	const debouncedFunc = (...args) => {
		if (timeout === -1) {
			func(...args);
			timeout = window.setTimeout(() => {
				clearTimeout(timeout);
				timeout = -1;
			}, delay_ms);
			return;
		}
		clearTimeout(timeout);
		const later = () => {
			clearTimeout(timeout);
			timeout = -1;
			func(...args);
		};
		timeout = window.setTimeout(later, delay_ms);
	};
	return debouncedFunc;
}
function getDocumentScrollbarWidth() {
	return window.innerWidth - document.documentElement.clientWidth;
}
function makeArray(a) {
	if (a === null || a === void 0) return [];
	return a instanceof Array ? a : [a];
}
function roundToDigits(value, digits) {
	const multiplier = Math.pow(10, digits);
	return Math.round(value * multiplier) / multiplier;
}
//#endregion
//#region src/util/selectionHelperFunctions.ts
/**
* 
* @param previouslySelectedArray The list of previously selected items
* @param newlySelected      The item that should be selected or unselected
* @param selectMode         The selection mode that should be applied (see {@link SelectMode})
* @param allowUnselect      Whether the item should be unselected if it is already selected
* @returns The new list of selected items, or the newly selected item if the select mode is {@link SelectMode.Single}
* 
* This function implements the selection logic for components that display a list of items and allow
* the user to select (and possibly unselect) items. 
* 
* The selection logic is determined by the `selectMode` parameter, which can be one of the following:
* 
* - `SelectMode.None`: No selection is allowed. 
* - `SelectMode.Single`: Only one item can be selected at a time. 
* - `SelectMode.SingleArray`: Similar to `SelectMode.Single`, 
*    but the function will always return an array of selected items, even if there is only one selected item.
* 
* - `SelectMode.Multi`: Multiple items can be selected. 
* 
* If `allowUnselect` is `true`, and `newlySelectet` is an item that is already in the list of selected items, then
* the item will be removed from the list of selected items. If select mode is `SelectMode.Single`, the function
* returns `null` in this case.
*/
function handleSelection(previouslySelected, newlySelected, selectMode, allowUnselect, compareFunc) {
	let result = [...makeArray(previouslySelected)];
	let index = -1;
	for (let ii = 0; ii < result.length; ii++) if (compareFunc(result[ii]) == compareFunc(newlySelected)) {
		index = ii;
		break;
	}
	if (index >= 0 && allowUnselect) result.splice(index, 1);
	else switch (selectMode) {
		case SelectMode.None: break;
		case SelectMode.Single:
		case SelectMode.SingleArray:
			result = [newlySelected];
			break;
		case SelectMode.Multi: if (index == -1) result.push(newlySelected);
	}
	if (selectMode == SelectMode.Single) return result.length > 0 ? result[0] : null;
	return result;
}
//#endregion
//#region src/components/HeadlessList.vue
var HeadlessList_default = /* @__PURE__ */ defineComponent({
	__name: "HeadlessList",
	props: {
		allowUnselect: {
			type: Boolean,
			default: true
		},
		hover: {},
		items: { default: () => [] },
		compareFunc: {
			type: Function,
			default: (item) => item
		},
		selected: {},
		selectMode: { default: SelectMode.None }
	},
	emits: [
		"update:hover",
		"update:selected",
		"update:items"
	],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		function onItemClick(item) {
			const result = handleSelection(props.selected, item, props.selectMode, props.allowUnselect, props.compareFunc);
			emit("update:selected", result);
		}
		function isHover(item) {
			return props.hover === item;
		}
		function isSelected(item) {
			const selected = makeArray(props.selected);
			if (selected.includes(item)) return true;
			if (props.compareFunc) {
				const itemCompareValue = props.compareFunc(item);
				for (const i of selected) if (props.compareFunc(i) == itemCompareValue) return true;
			}
			return false;
		}
		return (_ctx, _cache) => {
			return openBlock(true), createElementBlock(Fragment, null, renderList(props.items, (item, index) => {
				return renderSlot(_ctx.$slots, "default", {
					key: index,
					item,
					index,
					isSelected: isSelected(item),
					isHover: isHover(item),
					onItemClick
				});
			}), 128);
		};
	}
});
//#endregion
//#region src/components/Combobox.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$25 = { class: "v-combobox" };
var _hoisted_2$18 = ["placeholder"];
var _hoisted_3$14 = { class: "v-combobox__panel" };
var _hoisted_4$12 = ["onClick"];
//#endregion
//#region src/components/Combobox.vue
var Combobox_default = /* @__PURE__ */ defineComponent({
	__name: "Combobox",
	props: {
		items: { default: () => [] },
		modelValue: { default: null },
		placeholder: { default: "" },
		filterFunc: {
			type: [Function, null],
			default: null
		},
		displayFunc: {
			type: Function,
			default: (item) => String(item)
		}
	},
	emits: ["update:modelValue"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const filterText = ref("");
		const isOpen = ref(false);
		const filteredItems = computed(() => {
			const text = filterText.value;
			if (!text) return props.items;
			if (props.filterFunc) return props.items.filter((item) => props.filterFunc(item, text));
			return props.items.filter((item) => String(item).toLowerCase().includes(text.toLowerCase()));
		});
		function onFocus() {
			filterText.value = "";
			isOpen.value = true;
		}
		function onBlur() {
			isOpen.value = false;
			filterText.value = "";
		}
		function selectItem(item) {
			emit("update:modelValue", item);
			filterText.value = "";
			isOpen.value = false;
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$25, [withDirectives(createElementVNode("input", {
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => filterText.value = $event),
				type: "text",
				class: "v-combobox__input",
				placeholder: __props.placeholder,
				onFocus,
				onClick: _cache[1] || (_cache[1] = ($event) => isOpen.value = true),
				onBlur
			}, null, 40, _hoisted_2$18), [[vModelText, filterText.value]]), withDirectives(createElementVNode("div", _hoisted_3$14, [createVNode(HeadlessList_default, {
				items: filteredItems.value,
				"select-mode": unref(SelectMode).None
			}, {
				default: withCtx(({ item }) => [createElementVNode("div", {
					class: "v-combobox__item",
					onMousedown: _cache[2] || (_cache[2] = withModifiers(() => {}, ["prevent"])),
					onClick: ($event) => selectItem(item)
				}, [renderSlot(_ctx.$slots, "item", { item }, () => [createTextVNode(toDisplayString(item), 1)])], 40, _hoisted_4$12)]),
				_: 3
			}, 8, ["items", "select-mode"])], 512), [[vShow, isOpen.value]])]);
		};
	}
});
//#endregion
//#region src/util/urlParamsUtils.ts
function readUrlParams() {
	const url_params = {};
	const params = new URL(window.location.href).searchParams;
	const keys = Array();
	params.forEach((value, key) => {
		keys.push(key);
	});
	for (const key of keys) {
		const param = params.get(key);
		if (param == null) continue;
		let value;
		try {
			value = JSON.parse(param);
		} catch (e) {
			try {
				value = JSON.parse("\"" + param + "\"");
			} catch (e) {
				value = param;
			}
		}
		if (value != "") url_params[key] = value;
		else delete url_params[key];
	}
	return url_params;
}
function updateBrowserUrl(params) {
	const url = new URL(window.location.href);
	for (const key in params) if (params[key] !== void 0) url.searchParams.set(key, params[key]);
	else url.searchParams.delete(key);
	history.replaceState(void 0, "", url.toString());
}
//#endregion
//#region src/components/DashboardPanel.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$24 = ["id"];
var _hoisted_2$17 = { class: "v-dashboard-panel__header" };
var _hoisted_3$13 = { class: "v-dashboard-panel__header-left" };
var _hoisted_4$11 = { class: "v-dashboard-panel__body" };
//#endregion
//#region src/components/DashboardPanel.vue
var DashboardPanel_default = /* @__PURE__ */ defineComponent({
	__name: "DashboardPanel",
	props: {
		fullWindow: {
			type: Boolean,
			default: false
		},
		id: {},
		showFullscreenButton: {
			type: Boolean,
			default: false
		},
		urlParamFullscreen: { default: "fullscreenPanel" }
	},
	setup(__props) {
		const props = __props;
		const customButtonsArea = ref(null);
		const fullWindowBackend = ref(props.fullWindow);
		const sfb = computed(() => {
			return props.showFullscreenButton || fullWindow.value;
		});
		const fullWindow = computed({
			get() {
				return fullWindowBackend.value;
			},
			set(newval) {
				fullWindowBackend.value = newval;
				if (fullWindowBackend.value) updateBrowserUrl({ [props.urlParamFullscreen]: props.id });
				else updateBrowserUrl({ [props.urlParamFullscreen]: void 0 });
			}
		});
		provide("externalToolbar", customButtonsArea);
		onMounted(() => {
			const urlParams = readUrlParams();
			if (urlParams?.fullscreenPanel && urlParams?.[props.urlParamFullscreen] == props.id) fullWindow.value = true;
		});
		function getFullscreenButtonTooltip() {
			return fullWindow.value ? "Vollbildmodus beenden" : "Panel auf Vollbild vergrößern";
		}
		return (_ctx, _cache) => {
			const _directive_full_window = resolveDirective("full-window");
			return withDirectives((openBlock(), createElementBlock("div", {
				id: props.id,
				class: "v-dashboard-panel"
			}, [createElementVNode("div", _hoisted_2$17, [createElementVNode("div", _hoisted_3$13, [renderSlot(_ctx.$slots, "header-left")]), createElementVNode("div", {
				ref_key: "customButtonsArea",
				ref: customButtonsArea,
				class: "v-dashboard-panel__header-right"
			}, [sfb.value ? (openBlock(), createBlock(SmartButton_default, {
				key: 0,
				modelValue: fullWindow.value,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => fullWindow.value = $event),
				set: true,
				unset: false,
				"data-tooltip": getFullscreenButtonTooltip()
			}, {
				default: withCtx(() => [..._cache[1] || (_cache[1] = [createElementVNode("img", { src: "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='iso-8859-1'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2016.0.0,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3c!DOCTYPE%20svg%20PUBLIC%20'-//W3C//DTD%20SVG%201.1//EN'%20'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg%20version='1.1'%20id='Capa_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20width='402.996px'%20height='402.996px'%20viewBox='0%200%20402.996%20402.996'%20style='enable-background:new%200%200%20402.996%20402.996;'%20xml:space='preserve'%3e%3cg%3e%3cg%3e%3cpath%20d='M392.996,1.985H258.33c-5.523,0-10,4.477-10,10V31.01c0,5.523,4.477,10,10,10h78.046L224.955,152.431%20c-3.905,3.905-3.905,10.237,0,14.142l13.453,13.453c1.953,1.953,4.512,2.929,7.07,2.929c2.56,0,5.119-0.977,7.071-2.929%20L363.972,68.604v78.047c0,5.523,4.478,10,10,10h19.024c5.523,0,10-4.477,10-10V11.985C402.996,6.462,398.52,1.985,392.996,1.985z'%20/%3e%3cpath%20d='M66.62,41.01h78.046c5.523,0,10-4.477,10-10V11.985c0-5.523-4.477-10-10-10H10c-5.523,0-10,4.477-10,10v134.666%20c0,5.523,4.477,10,10,10h19.024c5.523,0,10-4.477,10-10V68.604l111.422,111.421c1.952,1.953,4.512,2.929,7.071,2.929%20s5.119-0.977,7.071-2.929l13.453-13.453c3.905-3.905,3.905-10.237,0-14.142L66.62,41.01z'/%3e%3cpath%20d='M392.996,246.344h-19.024c-5.522,0-10,4.478-10,10v78.047L252.55,222.97c-3.903-3.905-10.237-3.905-14.142,0%20l-13.453,13.453c-3.905,3.904-3.905,10.236,0,14.142l111.421,111.421H258.33c-5.523,0-10,4.477-10,10v19.023%20c0,5.523,4.477,10,10,10h134.666c5.523,0,10-4.477,10-10V256.344C402.996,250.821,398.52,246.344,392.996,246.344z'/%3e%3cpath%20d='M164.588,222.97c-3.905-3.905-10.238-3.905-14.142,0L39.024,334.392v-78.047c0-5.523-4.477-10-10-10H10%20c-5.523,0-10,4.477-10,10v134.666c0,5.523,4.477,10,10,10h134.666c5.523,0,10-4.477,10-10v-19.023c0-5.523-4.477-10-10-10H66.62%20l111.421-111.422c3.905-3.904,3.905-10.236,0-14.143L164.588,222.97z'/%3e%3c/g%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3c/svg%3e" }, null, -1)])]),
				_: 1
			}, 8, ["modelValue", "data-tooltip"])) : createCommentVNode("", true), renderSlot(_ctx.$slots, "header-right")], 512)]), createElementVNode("div", _hoisted_4$11, [renderSlot(_ctx.$slots, "default")])], 8, _hoisted_1$24)), [[_directive_full_window, fullWindow.value]]);
		};
	}
});
//#endregion
//#region src/components/dualView/DualViewSyncModule.ts
var activeDualViewId = ref(null);
//#endregion
//#region src/util/Vector2.ts
var Vector2 = class Vector2 {
	constructor(x = 0, y = 0) {
		_defineProperty(this, "values", [0, 0]);
		this.values[0] = x;
		this.values[1] = y;
	}
	get x() {
		return this.values[0];
	}
	set x(newval) {
		this.values[0] = newval;
	}
	get y() {
		return this.values[1];
	}
	set y(newval) {
		this.values[1] = newval;
	}
	add(other) {
		return new Vector2(this.x + other.x, this.y + other.y);
	}
	clone() {
		return new Vector2(this.x, this.y);
	}
	dist(v2) {
		return this.sub(v2).len();
	}
	equals(other) {
		return this.x == other.x && this.y == other.y;
	}
	len() {
		return Math.sqrt(this.x * this.x + this.y * this.y);
	}
	scalarMult(value) {
		return new Vector2(this.x * value, this.y * value);
	}
	sub(other) {
		return new Vector2(this.x - other.x, this.y - other.y);
	}
	toString() {
		return "(" + this.x + ", " + this.y + ")";
	}
};
//#endregion
//#region src/composables/useViewportSize.ts
function useViewportSize() {
	const size = ref(new Vector2(window.innerWidth, window.innerHeight));
	onMounted(() => {
		window.addEventListener("resize", onResize);
	});
	onBeforeUnmount(() => {
		window.removeEventListener("resize", onResize);
	});
	function onResize() {
		size.value = new Vector2(window.innerWidth, window.innerHeight);
	}
	return size;
}
//#endregion
//#region src/composables/useEventListener.ts
function useEventListener(target, event, callback, options = void 0) {
	onMounted(() => {
		const elem = unref(target);
		if (elem != null) elem.addEventListener(event, callback, options);
	});
	onBeforeUnmount(() => {
		const elem = unref(target);
		if (elem != null) elem.removeEventListener(event, callback, options);
	});
}
//#endregion
//#region src/composables/useDragPosition.ts
function useDragPosition(target) {
	const pos = ref(new Vector2());
	const isDragging = ref(false);
	function onMouseDown(evt) {
		isDragging.value = true;
	}
	function onMouseMove(evt) {
		if (!isDragging.value) return;
		pos.value = new Vector2(evt.clientX, evt.clientY);
	}
	function onMouseUp(evt) {
		isDragging.value = false;
	}
	function onTouchEnd(evt) {
		isDragging.value = false;
	}
	function onTouchMove(evt) {
		if (!isDragging.value) return;
		const touch1 = evt.touches[0];
		pos.value = new Vector2(touch1.clientX, touch1.clientY);
	}
	function onTouchStart(evt) {
		isDragging.value = true;
	}
	useEventListener(target, "mousedown", onMouseDown);
	useEventListener(target, "touchstart", onTouchStart);
	useEventListener(document, "mousemove", onMouseMove);
	useEventListener(document, "mouseup", onMouseUp);
	useEventListener(document, "touchend", onTouchEnd);
	useEventListener(document, "touchmove", onTouchMove);
	return {
		pos,
		isDragging
	};
}
//#endregion
//#region src/components/dualView/DualView.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$23 = {
	key: 0,
	class: "v-dual-view__hint"
};
var _hoisted_2$16 = { class: "v-dual-view__panel__content" };
//#endregion
//#region src/components/dualView/DualView.vue
var DualView_default = /* @__PURE__ */ defineComponent({
	__name: "DualView",
	props: {
		allowClose: {
			type: Boolean,
			default: true
		},
		enabled: {
			type: Boolean,
			default: false
		},
		panelOnRight: {
			type: Boolean,
			default: false
		},
		ratio: { default: 50 },
		showHint: {
			type: Boolean,
			default: true
		}
	},
	emits: ["update:enabled"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const ratio = ref(props.ratio);
		watch(() => props.ratio, (newVal) => {
			ratio.value = newVal;
			updateSizes();
		});
		const drag_handle_h = ref(null);
		const drag_handle_v = ref(null);
		const { pos: dragPosH } = useDragPosition(drag_handle_h);
		const { pos: dragPosV } = useDragPosition(drag_handle_v);
		const viewportSize = useViewportSize();
		const myId = uuid.v4();
		const appElem = document.getElementById("app");
		if (appElem == null) console.error("DualView: No app element found!");
		const emit = __emit;
		const cssClass = computed(() => {
			return {
				"v-dual-view": true,
				"v-dual-view--enabled": props.enabled,
				"v-dual-view--disabled": !props.enabled
			};
		});
		const panelStyle = computed(() => {
			const result = {};
			if (props.enabled) {
				if (viewportSize.value.x > viewportSize.value.y) {
					if (!props.panelOnRight) result.left = "0%";
					else result.left = `${ratio.value}%`;
					result.width = `${100 - ratio.value}%`;
				} else result.bottom = `${ratio.value}%`;
			}
			return result;
		});
		function onCloseButtonClick() {
			activeDualViewId.value = null;
			resetAppElemStyles();
			emit("update:enabled", false);
		}
		function updateSizes() {
			if (!appElem) return;
			if (viewportSize.value.x > viewportSize.value.y) {
				if (!props.panelOnRight) appElem.style.left = `${100 - ratio.value}%`;
				else appElem.style.removeProperty("left");
				appElem.style.top = "0";
				appElem.style.bottom = "0";
				appElem.style.width = `${ratio.value}%`;
			} else {
				appElem.style.top = `${100 - ratio.value}%`;
				appElem.style.removeProperty("left");
			}
		}
		function resetAppElemStyles() {
			if (!appElem) return;
			appElem.classList.remove("v-dual-view-enabled-app");
			appElem.style.removeProperty("left");
			appElem.style.removeProperty("width");
			appElem.style.removeProperty("top");
			appElem.style.removeProperty("bottom");
		}
		function updateClasses() {
			if (!appElem) return;
			updateSizes();
			if (props.enabled) {
				activeDualViewId.value = myId;
				appElem.classList.add("v-dual-view-enabled-app");
				if (viewportSize.value.x > viewportSize.value.y) appElem.style.removeProperty("top");
				else appElem.style.removeProperty("width");
			} else if (activeDualViewId.value == null || activeDualViewId.value == myId) resetAppElemStyles();
		}
		watch(() => activeDualViewId.value, () => {
			if (activeDualViewId.value == myId) return;
			emit("update:enabled", false);
		});
		watch(() => [props.enabled, viewportSize.value], () => {
			updateClasses();
		}, { immediate: true });
		watch(() => dragPosH.value, () => {
			let newRatio = Math.round(dragPosH.value.x / window.innerWidth * 100);
			if (!props.panelOnRight) newRatio = 100 - newRatio;
			newRatio = Math.max(newRatio, 0);
			newRatio = Math.min(newRatio, 100);
			ratio.value = newRatio;
			updateSizes();
		});
		watch(() => dragPosV.value, () => {
			let newRatio = Math.round(dragPosV.value.y / window.innerHeight * 100);
			newRatio = Math.max(newRatio, 0);
			newRatio = Math.min(newRatio, 100);
			ratio.value = 100 - newRatio;
			updateSizes();
		});
		onMounted(() => {
			updateSizes();
			window.addEventListener("resize", updateSizes);
		});
		onBeforeUnmount(() => {
			onCloseButtonClick();
			window.removeEventListener("resize", updateSizes);
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(cssClass.value) }, [props.enabled && props.showHint ? (openBlock(), createElementBlock("div", _hoisted_1$23, [_cache[0] || (_cache[0] = createElementVNode("span", null, "Das Element an dieser Stelle wird im Moment als geteilte Ansicht dargestellt.", -1)), props.allowClose ? (openBlock(), createElementBlock("button", {
				key: 0,
				onClick: onCloseButtonClick
			}, " Geteilte Ansicht beenden ")) : createCommentVNode("", true)])) : createCommentVNode("", true), createElementVNode("div", {
				class: "v-dual-view__panel",
				style: normalizeStyle(panelStyle.value)
			}, [createElementVNode("div", _hoisted_2$16, [renderSlot(_ctx.$slots, "default")]), props.enabled ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
				props.allowClose ? (openBlock(), createElementBlock("button", {
					key: 0,
					"data-tooltip": "Geteilte Ansicht beenden",
					class: "v-dual-view__close-button",
					onClick: onCloseButtonClick
				}, [..._cache[1] || (_cache[1] = [createElementVNode("img", { src: "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'%20standalone='no'?%3e%3csvg%20xmlns:dc='http://purl.org/dc/elements/1.1/'%20xmlns:cc='http://creativecommons.org/ns%23'%20xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23'%20xmlns:svg='http://www.w3.org/2000/svg'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd'%20xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape'%20version='1.1'%20id='Layer_1'%20x='0px'%20y='0px'%20viewBox='0%200%201792%201792'%20style='enable-background:new%200%200%201792%201792;'%20xml:space='preserve'%20sodipodi:docname='cross-white.svg'%20inkscape:version='0.92.5%20(2060ec1f9f,%202020-04-08)'%3e%3cmetadata%20id='metadata9'%3e%3crdf:RDF%3e%3ccc:Work%20rdf:about=''%3e%3cdc:format%3eimage/svg+xml%3c/dc:format%3e%3cdc:type%20rdf:resource='http://purl.org/dc/dcmitype/StillImage'%20/%3e%3cdc:title%3e%3c/dc:title%3e%3c/cc:Work%3e%3c/rdf:RDF%3e%3c/metadata%3e%3cdefs%20id='defs7'%20/%3e%3csodipodi:namedview%20pagecolor='%23ffffff'%20bordercolor='%23666666'%20borderopacity='1'%20objecttolerance='10'%20gridtolerance='10'%20guidetolerance='10'%20inkscape:pageopacity='0'%20inkscape:pageshadow='2'%20inkscape:window-width='999'%20inkscape:window-height='480'%20id='namedview5'%20showgrid='false'%20inkscape:zoom='0.13169643'%20inkscape:cx='896'%20inkscape:cy='896'%20inkscape:window-x='0'%20inkscape:window-y='0'%20inkscape:window-maximized='0'%20inkscape:current-layer='Layer_1'%20/%3e%3cpath%20d='M1082.2,896.6l410.2-410c51.5-51.5,51.5-134.6,0-186.1s-134.6-51.5-186.1,0l-410.2,410L486,300.4%20c-51.5-51.5-134.6-51.5-186.1,0s-51.5,134.6,0,186.1l410.2,410l-410.2,410c-51.5,51.5-51.5,134.6,0,186.1%20c51.6,51.5,135,51.5,186.1,0l410.2-410l410.2,410c51.5,51.5,134.6,51.5,186.1,0c51.1-51.5,51.1-134.6-0.5-186.2L1082.2,896.6z'%20id='path2'%20style='fill:%23ffffff'%20/%3e%3c/svg%3e" }, null, -1)])])) : createCommentVNode("", true),
				withDirectives(createElementVNode("div", {
					ref_key: "drag_handle_h",
					ref: drag_handle_h,
					tabindex: "-1",
					class: normalizeClass(`v-dual-view__handle v-dual-view__handle_h ${props.panelOnRight ? "x-right" : "x-left"}`),
					draggable: "false",
					"data-tooltip": "Hier ziehen, um die geteilte Ansicht zu skalieren"
				}, null, 2), [[vShow, unref(viewportSize).x > unref(viewportSize).y]]),
				withDirectives(createElementVNode("div", {
					ref_key: "drag_handle_v",
					ref: drag_handle_v,
					tabindex: "-1",
					class: "v-dual-view__handle v-dual-view__handle_v",
					draggable: "false",
					"data-tooltip": "Hier ziehen, um die geteilte Ansicht zu skalieren"
				}, null, 512), [[vShow, unref(viewportSize).x < unref(viewportSize).y]])
			], 64)) : createCommentVNode("", true)], 4)], 2);
		};
	}
});
//#endregion
//#region src/components/HighlightText.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$22 = ["innerHTML"];
//#endregion
//#region src/components/HighlightText.vue
var HighlightText_default = /* @__PURE__ */ defineComponent({
	__name: "HighlightText",
	props: {
		highlight: { default: "" },
		text: { default: "" },
		caseSensitive: {
			type: Boolean,
			default: false
		}
	},
	setup(__props) {
		const props = __props;
		let text_lc, highlight_lc;
		const content = computed(() => {
			let t = props.text;
			if (props.highlight == "") return t;
			let offset = 0;
			while (true) {
				const pos = text_lc.indexOf(highlight_lc, offset);
				if (pos == -1) break;
				const replace = "<span>" + t.substring(pos, pos + highlight_lc.length) + "</span>";
				t = t.substring(0, pos) + replace + t.substring(pos + highlight_lc.length);
				offset = pos + replace.length + 1;
			}
			return t;
		});
		watch(() => props.highlight, () => {
			highlight_lc = props.highlight.toLocaleLowerCase();
		}, { immediate: true });
		watch(() => props.text, () => {
			text_lc = props.text.toLocaleLowerCase();
		}, { immediate: true });
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("span", {
				class: "v-highlight-text",
				innerHTML: content.value
			}, null, 8, _hoisted_1$22);
		};
	}
});
//#endregion
//#region src/components/List.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$21 = {
	class: "v-list",
	role: "list"
};
var _hoisted_2$15 = [
	"data-tooltip",
	"onMouseover",
	"onClick"
];
var _hoisted_3$12 = { style: { "flex": "1" } };
var _hoisted_4$10 = ["onClick"];
//#endregion
//#region src/components/List.vue
var List_default = /* @__PURE__ */ defineComponent({
	__name: "List",
	props: {
		allowUnselect: {
			type: Boolean,
			default: true
		},
		hover: {},
		items: { default: () => [] },
		compareFunc: {},
		liStyleFunc: {},
		onClick: {
			type: Function,
			default: () => {}
		},
		onRemoveButtonClick: {},
		removeButtons: {
			type: Boolean,
			default: false
		},
		selected: { default: null },
		selectMode: { default: SelectMode.Single },
		tooltipFunc: {
			type: Function,
			default: () => ""
		}
	},
	emits: [
		"update:hover",
		"update:selected",
		"update:items"
	],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const hoverItem = computed(() => makeArray(props.hover)[0] ?? null);
		function getDynamicClasses(item, isSelected, isHover) {
			return {
				"v-list__item": true,
				"x-hover": isHover,
				"x-selected": isSelected,
				"x-no-unselect": isSelected && !props.allowUnselect
			};
		}
		function getTooltipText(item) {
			const f = props.tooltipFunc;
			if (typeof f == "function") return f(item);
			return "";
		}
		function handleItemClick(item, headlessOnItemClick) {
			props.onClick(item);
			headlessOnItemClick(item);
		}
		function handleRemoveButtonClick(item, e) {
			e.stopPropagation();
			if (props.onRemoveButtonClick) {
				props.onRemoveButtonClick(item);
				return;
			}
			const items_cloned = makeArray(props.items);
			const index = items_cloned.indexOf(item);
			items_cloned.splice(index, 1);
			emit("update:items", items_cloned);
		}
		function onItemKeyDown(evt) {
			const target = evt.currentTarget;
			if (!target) return;
			let next;
			switch (evt.key) {
				case "ArrowUp":
				case "ArrowLeft":
					next = target.previousElementSibling;
					break;
				case "ArrowDown":
				case "ArrowRight": next = target.nextElementSibling;
			}
			if (next) {
				const button = next.firstElementChild?.firstElementChild;
				if (button) {
					button.focus();
					evt.preventDefault();
				}
			}
		}
		function onItemMouseOver(item) {
			emit("update:hover", item);
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("ul", _hoisted_1$21, [createVNode(HeadlessList_default, {
				items: props.items,
				selected: props.selected,
				hover: hoverItem.value,
				"compare-func": props.compareFunc,
				"allow-unselect": props.allowUnselect,
				"select-mode": props.selectMode,
				"onUpdate:selected": _cache[0] || (_cache[0] = ($event) => emit("update:selected", $event))
			}, {
				default: withCtx(({ item, isSelected, isHover, onItemClick: headlessOnItemClick }) => [createElementVNode("li", {
					class: normalizeClass(getDynamicClasses(item, isSelected, isHover)),
					style: normalizeStyle(props.liStyleFunc ? props.liStyleFunc(item) : ""),
					"data-tooltip": getTooltipText(item),
					onMouseover: ($event) => onItemMouseOver(item),
					onKeydown: onItemKeyDown,
					onClick: ($event) => handleItemClick(item, headlessOnItemClick)
				}, [createElementVNode("div", null, [createElementVNode("button", _hoisted_3$12, [renderSlot(_ctx.$slots, "item", { item }, () => [createTextVNode(toDisplayString(item), 1)])]), props.removeButtons ? (openBlock(), createElementBlock("button", {
					key: 0,
					class: "v-list-item-remove-button",
					"data-tooltip": "Entfernen",
					"aria-label": "Entfernen",
					onClick: ($event) => handleRemoveButtonClick(item, $event)
				}, null, 8, _hoisted_4$10)) : createCommentVNode("", true)])], 46, _hoisted_2$15)]),
				_: 3
			}, 8, [
				"items",
				"selected",
				"hover",
				"compare-func",
				"allow-unselect",
				"select-mode"
			])]);
		};
	}
});
//#endregion
//#region src/components/Spinner.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$20 = { class: "v-spinner" };
//#endregion
//#region src/components/Spinner.vue
var Spinner_default = /* @__PURE__ */ defineComponent({
	__name: "Spinner",
	props: {
		color: { default: "#66f" },
		thickness: { default: "8px" }
	},
	setup(__props) {
		const props = __props;
		function getStyle() {
			const p = props.thickness;
			return `background:
        radial-gradient(farthest-side, ${props.color} 94%, #0000) top/${p} ${p} no-repeat,
        conic-gradient(#0000 30%, ${props.color});

    -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - ${p}), #000 0);`;
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$20, [createElementVNode("div", {
				class: "v-spinner__animation",
				style: normalizeStyle(getStyle())
			}, null, 4)]);
		};
	}
});
//#endregion
//#region src/components/LoadingIndicatorOverlay.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$19 = { class: "v-loading-indicator-overlay" };
//#endregion
//#region src/components/LoadingIndicatorOverlay.vue
var LoadingIndicatorOverlay_default = /* @__PURE__ */ defineComponent({
	__name: "LoadingIndicatorOverlay",
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$19, [createElementVNode("div", null, [createVNode(Spinner_default)]), _cache[0] || (_cache[0] = createElementVNode("div", null, "Lade Daten ...", -1))]);
		};
	}
});
//#endregion
//#region src/components/SmartSelect.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$18 = ["innerHTML"];
var _hoisted_2$14 = ["innerHTML"];
var _hoisted_3$11 = ["value"];
var _hoisted_4$9 = {
	key: 1,
	class: "v-smart-select",
	disabled: "true"
};
//#endregion
//#region src/components/SmartSelect.vue
var SmartSelect_default = /* @__PURE__ */ defineComponent({
	__name: "SmartSelect",
	props: {
		initiallySelectedIndex: {},
		labelFunc: {},
		modelValue: {},
		nullOption: {
			type: Boolean,
			default: false
		},
		options: { default: () => [] },
		orderByLabel: {
			type: Boolean,
			default: true
		},
		nullOptionLabel: { default: "- Keine Auswahl -" },
		valueFunc: {}
	},
	emits: ["change", "update:modelValue"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const options = computed({
			get() {
				const result = [...props.options];
				if (props.orderByLabel) {
					const f = props.labelFunc;
					if (typeof f == "function") {
						const sortFunc = (a, b) => {
							const aa = f(a);
							const bb = f(b);
							if (aa < bb) return -1;
							else if (aa > bb) return 1;
							return 0;
						};
						result.sort(sortFunc);
					} else result.sort();
				}
				return result;
			},
			set(newValue) {}
		});
		const value = computed({
			get() {
				for (const option of options.value) {
					const optionValue = getOptionValue(option);
					if (props.modelValue == optionValue) return props.modelValue;
					if (JSON.stringify(optionValue) == JSON.stringify(props.modelValue)) return props.modelValue;
				}
			},
			set(newValue) {
				emit("update:modelValue", newValue);
				emit("change", newValue);
			}
		});
		function getOptionLabel(option) {
			if (typeof props.labelFunc == "function") return props.labelFunc(option);
			return option;
		}
		function getOptionValue(option) {
			if (typeof props.valueFunc == "function") return props.valueFunc(option);
			return option;
		}
		return (_ctx, _cache) => {
			return options.value.length > 0 ? withDirectives((openBlock(), createElementBlock("select", {
				key: 0,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event),
				class: "v-smart-select"
			}, [
				createElementVNode("option", {
					hidden: "",
					value: void 0,
					innerHTML: props.nullOptionLabel
				}, null, 8, _hoisted_1$18),
				__props.nullOption ? (openBlock(), createElementBlock("option", {
					key: 0,
					value: null,
					class: "v-smart-select__null-option",
					innerHTML: props.nullOptionLabel
				}, null, 8, _hoisted_2$14)) : createCommentVNode("", true),
				(openBlock(true), createElementBlock(Fragment, null, renderList(options.value, (option) => {
					return openBlock(), createElementBlock("option", { value: getOptionValue(option) }, toDisplayString(getOptionLabel(option)), 9, _hoisted_3$11);
				}), 256))
			], 512)), [[vModelSelect, value.value]]) : (openBlock(), createElementBlock("select", _hoisted_4$9, [..._cache[1] || (_cache[1] = [createElementVNode("option", null, "Keine Option verfügbar", -1)])]));
		};
	}
});
//#endregion
//#region src/components/PaginationControl.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$17 = ["aria-label"];
var _hoisted_2$13 = {
	key: 0,
	class: "v-pagination-control__compact"
};
var _hoisted_3$10 = ["disabled"];
var _hoisted_4$8 = ["disabled"];
var _hoisted_5 = { key: 1 };
var _hoisted_6 = [
	"disabled",
	"aria-label",
	"aria-current",
	"onClick",
	"innerHTML"
];
//#endregion
//#region src/components/PaginationControl.vue
var PaginationControl_default = /* @__PURE__ */ defineComponent({
	__name: "PaginationControl",
	props: {
		label: { default: "Pagination" },
		totalItems: {},
		pageSize: {},
		currentPage: { default: 0 },
		mode: { default: "default" }
	},
	emits: ["update:currentPage"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const localCurrentPage = ref(props.currentPage);
		const totalPages = computed(() => {
			return Math.ceil(props.totalItems / props.pageSize);
		});
		const pageNumbers = computed(() => {
			const pages = [];
			for (let i = 0; i < totalPages.value; i++) pages.push(i);
			return pages;
		});
		const isFirstPage = computed(() => localCurrentPage.value === 0);
		const isLastPage = computed(() => localCurrentPage.value === totalPages.value - 1);
		const goToPage = (page) => {
			if (page < 0 || page >= totalPages.value) return;
			emit("update:currentPage", localCurrentPage.value);
		};
		const nextPage = () => {
			if (!isLastPage.value) emit("update:currentPage", localCurrentPage.value + 1);
		};
		const prevPage = () => {
			if (!isFirstPage.value) emit("update:currentPage", localCurrentPage.value - 1);
		};
		watch(() => localCurrentPage.value, (newPage) => {
			if (newPage < 0 || newPage >= totalPages.value) emit("update:currentPage", 0);
			else emit("update:currentPage", newPage);
		});
		watch(() => props.currentPage, (newPage) => {
			localCurrentPage.value = newPage;
		});
		watch(() => props.totalItems, (newTotal) => {
			if (Math.ceil(newTotal / props.pageSize) < localCurrentPage.value + 1) emit("update:currentPage", 0);
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("nav", {
				class: "v-pagination-control",
				"aria-label": props.label
			}, [props.mode == "compact" ? (openBlock(), createElementBlock("div", _hoisted_2$13, [
				createElementVNode("button", {
					disabled: isFirstPage.value,
					"aria-label": "Previous Page",
					onClick: prevPage
				}, [..._cache[1] || (_cache[1] = [createElementVNode("img", {
					style: { "transform": "rotate(180deg)" },
					src: "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'%20standalone='no'?%3e%3csvg%20xmlns:dc='http://purl.org/dc/elements/1.1/'%20xmlns:cc='http://creativecommons.org/ns%23'%20xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23'%20xmlns:svg='http://www.w3.org/2000/svg'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd'%20xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape'%20version='1.1'%20id='Layer_1'%20x='0px'%20y='0px'%20viewBox='0%200%20512%20512'%20enable-background='new%200%200%20512%20512'%20xml:space='preserve'%20sodipodi:docname='right-open.svg'%20inkscape:version='0.92.5%20(2060ec1f9f,%202020-04-08)'%3e%3cmetadata%20id='metadata9'%3e%3crdf:RDF%3e%3ccc:Work%20rdf:about=''%3e%3cdc:format%3eimage/svg+xml%3c/dc:format%3e%3cdc:type%20rdf:resource='http://purl.org/dc/dcmitype/StillImage'%20/%3e%3cdc:title%3e%3c/dc:title%3e%3c/cc:Work%3e%3c/rdf:RDF%3e%3c/metadata%3e%3cdefs%20id='defs7'%20/%3e%3csodipodi:namedview%20pagecolor='%23ffffff'%20bordercolor='%23666666'%20borderopacity='1'%20objecttolerance='10'%20gridtolerance='10'%20guidetolerance='10'%20inkscape:pageopacity='0'%20inkscape:pageshadow='2'%20inkscape:window-width='870'%20inkscape:window-height='480'%20id='namedview5'%20showgrid='false'%20inkscape:zoom='0.4609375'%20inkscape:cx='256'%20inkscape:cy='256'%20inkscape:window-x='0'%20inkscape:window-y='0'%20inkscape:window-maximized='0'%20inkscape:current-layer='Layer_1'%20/%3e%3cpolygon%20points='0,162.9%20256,418.9%20512,162.9%20442.2,93.1%20256,279.3%2069.8,93.1%20'%20id='polygon2'%20transform='rotate(-90,256,256)'%20/%3e%3c/svg%3e",
					alt: ""
				}, null, -1)])], 8, _hoisted_3$10),
				createVNode(SmartSelect_default, {
					"model-value": localCurrentPage.value,
					"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => localCurrentPage.value = $event),
					label: "Select Page",
					options: pageNumbers.value,
					"label-func": (page) => page + 1 + "/" + totalPages.value,
					"order-by-label": false
				}, null, 8, [
					"model-value",
					"options",
					"label-func"
				]),
				createElementVNode("button", {
					disabled: isLastPage.value,
					"aria-label": "Next Page",
					onClick: nextPage
				}, [..._cache[2] || (_cache[2] = [createElementVNode("img", {
					src: "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'%20standalone='no'?%3e%3csvg%20xmlns:dc='http://purl.org/dc/elements/1.1/'%20xmlns:cc='http://creativecommons.org/ns%23'%20xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23'%20xmlns:svg='http://www.w3.org/2000/svg'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd'%20xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape'%20version='1.1'%20id='Layer_1'%20x='0px'%20y='0px'%20viewBox='0%200%20512%20512'%20enable-background='new%200%200%20512%20512'%20xml:space='preserve'%20sodipodi:docname='right-open.svg'%20inkscape:version='0.92.5%20(2060ec1f9f,%202020-04-08)'%3e%3cmetadata%20id='metadata9'%3e%3crdf:RDF%3e%3ccc:Work%20rdf:about=''%3e%3cdc:format%3eimage/svg+xml%3c/dc:format%3e%3cdc:type%20rdf:resource='http://purl.org/dc/dcmitype/StillImage'%20/%3e%3cdc:title%3e%3c/dc:title%3e%3c/cc:Work%3e%3c/rdf:RDF%3e%3c/metadata%3e%3cdefs%20id='defs7'%20/%3e%3csodipodi:namedview%20pagecolor='%23ffffff'%20bordercolor='%23666666'%20borderopacity='1'%20objecttolerance='10'%20gridtolerance='10'%20guidetolerance='10'%20inkscape:pageopacity='0'%20inkscape:pageshadow='2'%20inkscape:window-width='870'%20inkscape:window-height='480'%20id='namedview5'%20showgrid='false'%20inkscape:zoom='0.4609375'%20inkscape:cx='256'%20inkscape:cy='256'%20inkscape:window-x='0'%20inkscape:window-y='0'%20inkscape:window-maximized='0'%20inkscape:current-layer='Layer_1'%20/%3e%3cpolygon%20points='0,162.9%20256,418.9%20512,162.9%20442.2,93.1%20256,279.3%2069.8,93.1%20'%20id='polygon2'%20transform='rotate(-90,256,256)'%20/%3e%3c/svg%3e",
					alt: ""
				}, null, -1)])], 8, _hoisted_4$8)
			])) : createCommentVNode("", true), props.mode == "default" ? (openBlock(), createElementBlock("ul", _hoisted_5, [(openBlock(true), createElementBlock(Fragment, null, renderList(pageNumbers.value, (page) => {
				return openBlock(), createElementBlock("li", { key: page }, [createElementVNode("button", {
					class: normalizeClass({ active: page === __props.currentPage }),
					disabled: page === __props.currentPage,
					"aria-label": "Page " + (page + 1),
					"aria-current": page === __props.currentPage ? "page" : void 0,
					onClick: ($event) => goToPage(page),
					innerHTML: page + 1
				}, null, 10, _hoisted_6)]);
			}), 128))])) : createCommentVNode("", true)], 8, _hoisted_1$17);
		};
	}
});
//#endregion
//#region src/composables/useOnOutsideClick.ts
function useOnOutsideClick(target, callback) {
	function onWindowMouseDown(evt) {
		const elem = unref(target);
		if (elem == null || elem == evt.target || elem.contains(evt.target)) return;
		callback(evt);
	}
	useEventListener(document, "mousedown", onWindowMouseDown);
}
//#endregion
//#region src/components/Popup.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$16 = {
	key: 0,
	class: "v-popup__clickblocker"
};
var _hoisted_2$12 = { class: "v-popup__header" };
var _hoisted_3$9 = ["innerHTML"];
var _hoisted_4$7 = { class: "v-popup__body" };
//#endregion
//#region src/components/Popup.vue
var Popup_default = /* @__PURE__ */ defineComponent({
	__name: "Popup",
	props: {
		allowOutsideInteraction: {
			type: Boolean,
			default: false
		},
		closeOnOutsideClick: {
			type: Boolean,
			default: true
		},
		docked: {
			type: Boolean,
			default: false
		},
		show: { type: Boolean },
		showDockButton: {
			type: Boolean,
			default: false
		},
		title: {}
	},
	emits: [
		"update:show",
		"update:docked",
		"close"
	],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const panel = ref(null);
		const rootElem = ref(null);
		useOnOutsideClick(panel, onOutsideClick);
		const showDelayed = ref(false);
		const docked = ref(props.docked);
		function getClasses() {
			return {
				"v-popup": true,
				"x-docked": docked.value,
				"v-popup--visible": showDelayed.value,
				"v-popup--hidden": !showDelayed.value
			};
		}
		function hide() {
			emit("update:show", false);
			emit("close");
		}
		function onOutsideClick(_evt) {
			if (docked.value) return;
			if (showDelayed.value && props.closeOnOutsideClick) hide();
		}
		watch(() => props.show, (newval) => {
			if (rootElem.value) document.getElementsByTagName("body")[0].appendChild(rootElem.value);
			if (newval && !props.allowOutsideInteraction) {
				document.body.style.marginRight = getDocumentScrollbarWidth() + "px";
				document.body.style.overflow = "hidden";
			} else {
				document.body.style.removeProperty("overflow");
				document.body.style.removeProperty("margin-right");
			}
			window.setTimeout(() => {
				showDelayed.value = newval;
			}, 0);
		}, { immediate: true });
		watch(() => docked.value, () => {
			emit("update:docked", docked.value);
		});
		watch(() => props.docked, (newval) => {
			docked.value = newval;
		}, { immediate: true });
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "rootElem",
				ref: rootElem,
				class: normalizeClass(getClasses())
			}, [showDelayed.value && !__props.allowOutsideInteraction ? (openBlock(), createElementBlock("div", _hoisted_1$16)) : createCommentVNode("", true), createElementVNode("div", {
				ref_key: "panel",
				ref: panel,
				class: "v-popup__panel"
			}, [createElementVNode("div", _hoisted_2$12, [
				createElementVNode("h1", { innerHTML: __props.title }, null, 8, _hoisted_3$9),
				props.showDockButton ? (openBlock(), createBlock(SmartButton_default, {
					key: 0,
					modelValue: docked.value,
					"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => docked.value = $event),
					class: "v-popup__header__button-dock",
					boolean: "",
					"data-tooltip": docked.value ? "Ablösen" : "Anpinnen"
				}, null, 8, ["modelValue", "data-tooltip"])) : createCommentVNode("", true),
				createElementVNode("button", {
					class: "v-popup__header__button-close",
					"data-tooltip": "Schließen",
					onClick: hide
				})
			]), createElementVNode("div", _hoisted_4$7, [renderSlot(_ctx.$slots, "default")])], 512)], 2);
		};
	}
});
//#endregion
//#region src/components/ProgressBar.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$15 = [
	"data-tooltip",
	"aria-valuenow",
	"aria-valuemin",
	"aria-valuemax",
	"aria-valuetext",
	"aria-label"
];
var _hoisted_2$11 = { class: "v-progress-bar__background" };
//#endregion
//#region src/components/ProgressBar.vue
var ProgressBar_default = /* @__PURE__ */ defineComponent({
	__name: "ProgressBar",
	props: {
		label: { default: "progress" },
		colorFunc: {},
		tooltipFunc: {},
		max: { default: 1 },
		min: { default: 0 },
		value: { default: .5 }
	},
	setup(__props) {
		const props = __props;
		const barClass = computed(() => {
			return {
				"v-progress-bar": true,
				"x-positive": props.value > 0,
				"x-negative": props.value < 0
			};
		});
		const barStyle = computed(() => {
			return {
				left: getLeft() * 100 + "%",
				width: getWidth() * 100 + "%",
				"background-color": typeof props.colorFunc === "function" ? props.colorFunc(scale(props.value)) : void 0
			};
		});
		function getWidth() {
			return Math.abs(scale(props.value) - scale(0));
		}
		function getLeft() {
			return props.value >= 0 ? scale(0) : scale(0) - getWidth();
		}
		function getTooltip() {
			if (typeof props.tooltipFunc == "function") return props.tooltipFunc(props.value);
			else return props.value.toString();
		}
		function scale(value) {
			const min = Math.min(props.min, 0);
			const range = Math.abs(props.max - min);
			return (value - min) / range;
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: normalizeClass(barClass.value),
				"data-tooltip": getTooltip(),
				role: "progressbar",
				"aria-valuenow": props.value,
				"aria-valuemin": props.min,
				"aria-valuemax": props.max,
				"aria-valuetext": getTooltip(),
				"aria-label": props.label
			}, [createElementVNode("div", _hoisted_2$11, [createElementVNode("div", {
				class: "v-progress-bar__bar",
				style: normalizeStyle(barStyle.value)
			}, null, 4)])], 10, _hoisted_1$15);
		};
	}
});
//#endregion
//#region src/components/PropertyGrid.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$14 = {
	key: 0,
	class: "v-property-grid"
};
var _hoisted_2$10 = ["innerHTML"];
var _hoisted_3$8 = ["innerHTML"];
//#endregion
//#region src/components/PropertyGrid.vue
var PropertyGrid_default = /* @__PURE__ */ defineComponent({
	__name: "PropertyGrid",
	props: {
		config: { default: () => ({}) },
		object: {}
	},
	setup(__props) {
		const props = __props;
		const displayedKeys = computed(() => {
			let result = Array();
			if (props.config?.showOnlyConfiguredFields) {
				result = Object.keys(props.config?.fields);
				return result;
			}
			for (const key in props.object) {
				if (props.config?.fields[key]?.show === false) continue;
				result.push(key);
			}
			result.sort();
			return result;
		});
		function getDisplayValue(key) {
			const propertyDef = props.config?.fields[key];
			if (propertyDef) {
				if (typeof propertyDef?.displayFunc == "function") return propertyDef.displayFunc(props.object);
				const value = (propertyDef.valueFunc || ((obj) => obj[key]))(props.object);
				switch (propertyDef.type) {
					case "url": return `<a target="_blank" href="${value}">${value}</a>`;
					case "email": return `<a target="_blank" href="mailto:${value}">${value}</a>`;
				}
			}
			switch (typeof props.object[key]) {
				case "object": return JSON.stringify(props.object[key]);
				case "string": return props.object[key];
				default: return JSON.stringify(props.object[key]);
			}
		}
		function getLabel(key) {
			return props.config?.fields?.[key]?.label || key;
		}
		return (_ctx, _cache) => {
			return props.object ? (openBlock(), createElementBlock("div", _hoisted_1$14, [(openBlock(true), createElementBlock(Fragment, null, renderList(displayedKeys.value, (key) => {
				return openBlock(), createElementBlock("div", null, [createElementVNode("h2", { innerHTML: getLabel(key) + ":" }, null, 8, _hoisted_2$10), createElementVNode("div", { innerHTML: getDisplayValue(key) }, null, 8, _hoisted_3$8)]);
			}), 256))])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/scrollSensor/ScrollSensor.vue
var ScrollSensor_default = /* @__PURE__ */ defineComponent({
	__name: "ScrollSensor",
	props: {
		info: { default: null },
		sensorOffsetYPercent: { default: 50 },
		updateOnResize: {
			type: Boolean,
			default: true
		},
		debug: {
			type: Boolean,
			default: false
		}
	},
	emits: ["update:info"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const sensorElemRef = ref(null);
		/** Viewport-relative bounding rect of the sensor element, updated on scroll and resize. */
		const sensorRect = ref(null);
		const emit = __emit;
		const scrollItems = Array();
		let prevItem = null;
		let currentItem = null;
		/** Tracks whether update() has run at least once, so the initial null state is always emitted. */
		let hasEmittedOnce = false;
		/** rAF handle for throttling updates. */
		let rafHandle = null;
		/** Collect all scrollable ancestors of the sensor element. */
		function getScrollAncestors(el) {
			const result = [];
			let current = el.parentElement;
			while (current) {
				const style = window.getComputedStyle(current);
				const overflow = style.overflow + style.overflowY + style.overflowX;
				if (/auto|scroll/.test(overflow)) result.push(current);
				current = current.parentElement;
			}
			result.push(document.documentElement);
			return result;
		}
		let scrollAncestors = [];
		let resizeObserver = null;
		function scheduleUpdate() {
			if (rafHandle !== null) return;
			rafHandle = requestAnimationFrame(() => {
				rafHandle = null;
				update();
			});
		}
		onMounted(() => {
			const el = sensorElemRef.value;
			if (!el) return;
			scrollAncestors = getScrollAncestors(el);
			for (const ancestor of scrollAncestors) ancestor.addEventListener("scroll", scheduleUpdate, { passive: true });
			window.addEventListener("scroll", scheduleUpdate, { passive: true });
			resizeObserver = new ResizeObserver(scheduleUpdate);
			resizeObserver.observe(el);
			for (const ancestor of scrollAncestors) resizeObserver.observe(ancestor);
			requestAnimationFrame(() => {
				update();
			});
		});
		onBeforeUnmount(() => {
			if (rafHandle !== null) {
				cancelAnimationFrame(rafHandle);
				rafHandle = null;
			}
			for (const ancestor of scrollAncestors) ancestor.removeEventListener("scroll", scheduleUpdate);
			window.removeEventListener("scroll", scheduleUpdate);
			resizeObserver?.disconnect();
			resizeObserver = null;
		});
		function addItem(item) {
			scrollItems.push(item);
			scheduleUpdate();
		}
		function emitInfo() {
			const info = markRaw({
				allItems: scrollItems,
				currentItem
			});
			emit("update:info", info);
		}
		function update() {
			if (!sensorElemRef.value) return;
			const scrollContainer = scrollAncestors[0] ?? document.documentElement;
			const containerBox = scrollContainer === document.documentElement ? new DOMRect(0, 0, window.innerWidth, window.innerHeight) : scrollContainer.getBoundingClientRect();
			const prev = sensorRect.value;
			if (!prev || prev.top !== containerBox.top || prev.left !== containerBox.left || prev.width !== containerBox.width || prev.height !== containerBox.height) sensorRect.value = containerBox;
			const sensorLine_y = containerBox.top + containerBox.height * (props.sensorOffsetYPercent / 100);
			currentItem = null;
			for (const item of scrollItems) {
				const itemBox = item.elem.getBoundingClientRect();
				if (itemBox.top <= sensorLine_y && itemBox.bottom >= sensorLine_y) {
					currentItem = item;
					break;
				}
			}
			if (prevItem !== currentItem || !hasEmittedOnce) {
				if (prevItem != null) {
					prevItem.props.onLeave?.();
					prevItem.elem.classList.remove("x-scroll-sensor-active");
				}
				if (currentItem != null) {
					currentItem.props.onEnter?.();
					currentItem.elem.classList.add("x-scroll-sensor-active");
				}
				hasEmittedOnce = true;
				emitInfo();
			}
			prevItem = currentItem;
		}
		provide("scroll-sensor", { addItem });
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock(Fragment, null, [createElementVNode("div", {
				ref_key: "sensorElemRef",
				ref: sensorElemRef,
				class: "v-scroll-sensor"
			}, [renderSlot(_ctx.$slots, "default")], 512), (openBlock(), createBlock(Teleport, { to: "body" }, [props.debug && sensorRect.value ? (openBlock(), createElementBlock("div", {
				key: 0,
				class: "v-scroll-sensor-debug-line",
				style: normalizeStyle({
					left: sensorRect.value.left + "px",
					top: sensorRect.value.top + sensorRect.value.height * (props.sensorOffsetYPercent / 100) + "px",
					width: sensorRect.value.width + "px"
				})
			}, null, 4)) : createCommentVNode("", true)]))], 64);
		};
	}
});
//#endregion
//#region src/components/scrollSensor/ScrollSensorItem.vue
var ScrollSensorItem_default = /* @__PURE__ */ defineComponent({
	__name: "ScrollSensorItem",
	props: {
		data: {},
		onEnter: { type: Function },
		onLeave: { type: Function }
	},
	setup(__props) {
		const props = __props;
		const scrollSensor = inject("scroll-sensor");
		const rootElem = ref(null);
		onMounted(() => {
			if (!scrollSensor) return;
			const elem = rootElem.value;
			if (!elem) return;
			scrollSensor.addItem({
				elem,
				props
			});
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "rootElem",
				ref: rootElem,
				class: "v-scroll-sensor-item"
			}, [renderSlot(_ctx.$slots, "default")], 512);
		};
	}
});
//#endregion
//#region src/components/scrollSensor/ScrollSensorMenu.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$13 = {
	key: 0,
	class: "v-scroll-sensor-menu"
};
var _hoisted_2$9 = ["data-tooltip"];
var _hoisted_3$7 = ["onClick"];
var _hoisted_4$6 = ["innerHTML"];
//#endregion
//#region src/components/scrollSensor/ScrollSensorMenu.vue
var ScrollSensorMenu_default = /* @__PURE__ */ defineComponent({
	__name: "ScrollSensorMenu",
	props: { data: {} },
	setup(__props) {
		const props = __props;
		return (_ctx, _cache) => {
			return props.data ? (openBlock(), createElementBlock("ul", _hoisted_1$13, [(openBlock(true), createElementBlock(Fragment, null, renderList(props.data.allItems, (item) => {
				return openBlock(), createElementBlock("li", {
					class: normalizeClass({ "x-selected": item == props.data.currentItem ? true : false }),
					"data-tooltip": item.props?.data?.label
				}, [createElementVNode("button", { onClick: ($event) => item.elem.scrollIntoView({
					behavior: "smooth",
					block: "start"
				}) }, [renderSlot(_ctx.$slots, "item-label", { item }, () => [createElementVNode("div", { innerHTML: item.props?.data?.label }, null, 8, _hoisted_4$6)])], 8, _hoisted_3$7)], 10, _hoisted_2$9);
			}), 256))])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/SmartRangeInput.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$12 = { class: "v-smart-range-input" };
var _hoisted_2$8 = {
	key: 0,
	class: "v-smart-range-input__range-label"
};
var _hoisted_3$6 = [
	"min",
	"max",
	"step",
	"data-tooltip"
];
var _hoisted_4$5 = {
	key: 1,
	class: "v-smart-range-input__range-label"
};
//#endregion
//#region src/components/SmartRangeInput.vue
var SmartRangeInput_default = /* @__PURE__ */ defineComponent({
	__name: "SmartRangeInput",
	props: {
		max: { default: 100 },
		min: { default: 1 },
		modelValue: { default: 0 },
		step: {},
		showLabels: {
			type: Boolean,
			default: true
		},
		tooltipFunc: {}
	},
	emits: ["update:modelValue"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const tooltipFunc = computed(() => {
			if (typeof props.tooltipFunc == "function") return props.tooltipFunc;
			return () => value.value;
		});
		const value = computed({
			get() {
				if (props.modelValue == void 0) return "";
				return props.modelValue.toString();
			},
			set(newValue) {
				emit("update:modelValue", parseFloat(newValue));
			}
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$12, [
				props.showLabels ? (openBlock(), createElementBlock("div", _hoisted_2$8, toDisplayString(props.min), 1)) : createCommentVNode("", true),
				withDirectives(createElementVNode("input", {
					"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event),
					type: "range",
					min: props.min,
					max: props.max,
					step: __props.step,
					"data-tooltip": tooltipFunc.value()
				}, null, 8, _hoisted_3$6), [[vModelText, value.value]]),
				props.showLabels ? (openBlock(), createElementBlock("div", _hoisted_4$5, toDisplayString(props.max), 1)) : createCommentVNode("", true)
			]);
		};
	}
});
//#endregion
//#region src/components/smartTable/SmartTable.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$11 = { class: "v-smart-table" };
var _hoisted_2$7 = [
	"data-tooltip",
	"aria-sort",
	"aria-label",
	"onClick",
	"onKeydown",
	"innerHTML"
];
var _hoisted_3$5 = [
	"onMouseover",
	"onMouseout",
	"onClick"
];
var _hoisted_4$4 = ["innerHTML"];
//#endregion
//#region src/components/smartTable/SmartTable.vue
var SmartTable_default = /* @__PURE__ */ defineComponent({
	__name: "SmartTable",
	props: {
		items: { default: () => [] },
		downloadFileName: { default: "table.csv" },
		fields: {},
		hover: { default: () => [] },
		initialSortField: { default: -1 },
		initialSortDir: { default: 1 },
		onBodyCellClick: {},
		selectMode: { default: SelectMode.None },
		selected: { default: () => [] },
		triggerDownload: {
			type: Boolean,
			default: false
		}
	},
	emits: [
		"update:hover",
		"update:selected",
		"update:selected-field",
		"row-mouse-out",
		"row-mouse-over",
		"row-click"
	],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const sortColIndex = ref(props.initialSortField);
		const sortDir = ref(props.initialSortDir > 0 ? 1 : -1);
		const emit = __emit;
		const fields = computed(() => {
			if (props.fields) return props.fields;
			if (!props.items) return [];
			let keys = Array();
			for (const row of props.items) keys = keys.concat(Object.keys(row));
			keys = Array.from(/* @__PURE__ */ new Set([...keys]));
			const result = Array();
			for (const key of keys) result.push({
				key,
				label: key
			});
			return result;
		});
		const rowsOrdered = computed(() => {
			let result = props.items;
			const sortColumn = fields.value[sortColIndex.value];
			if (!sortColumn || !isSortable(sortColumn)) return result;
			result = [...props.items].sort(compareItems);
			return result.filter((row) => row._sticky).concat(result.filter((row) => !row._sticky));
		});
		function compareItems(item1, item2) {
			const sortColumn = fields.value[sortColIndex.value];
			if (!sortColumn) return 0;
			const cf = typeof sortColumn.valueFunc == "function" ? sortColumn.valueFunc : (item) => item;
			const v1 = cf(item1);
			const v2 = cf(item2);
			if (v1 < v2) return -1 * sortDir.value;
			else if (v1 > v2) return 1 * sortDir.value;
			return 0;
		}
		function getDisplayString(item, col) {
			let result = item[col.key];
			if (typeof col.valueFunc == "function") try {
				result = col.valueFunc(item);
			} catch (e) {
				console.warn("SmartTable: Error in cell value function");
			}
			if (typeof col.displayFunc == "function") try {
				result = col.displayFunc(item);
			} catch (e) {
				console.warn("SmartTable: Error in cell value display function");
			}
			return result;
		}
		function getHeaderCellClass(field) {
			const colIndex = fields.value.indexOf(field);
			const result = {};
			if (field.htmlClass) result[field.htmlClass] = true;
			if (!isSortable(field)) return result;
			result["v-smart-table__header-cell-sortable"] = true;
			if (colIndex == sortColIndex.value) {
				result["v-smart-table__header-cell--asc"] = sortDir.value == 1;
				result["v-smart-table__header-cell--desc"] = sortDir.value == -1;
			} else result["v-smart-table__header-cell--unsorted"] = true;
			return result;
		}
		function getHeaderCellTooltip(col) {
			if (!isSortable(col)) return "";
			if (col.label) return `<strong>${sortDir.value < 0 ? "Aufsteigend" : "Absteigend"} nach ${col.label}</strong> sortieren`;
			else return "Nach dieser Spalte sortieren";
		}
		function getHeaderCellAriaSort(col) {
			if (!isSortable(col)) return;
			if (fields.value.indexOf(col) !== sortColIndex.value) return "none";
			return sortDir.value === 1 ? "ascending" : "descending";
		}
		function getHeaderCellAriaLabel(col) {
			let labelText = col.label ? col.label.replace(/<[^>]*>/g, "") : col.key;
			labelText = htmlConvert(labelText);
			if (!isSortable(col)) return labelText;
			const colIndex = fields.value.indexOf(col);
			let nextSortDir = sortDir.value;
			if (colIndex === sortColIndex.value) nextSortDir = -sortDir.value;
			return `${labelText}, ${nextSortDir > 0 ? "Aufsteigend sortieren" : "Absteigend sortieren"}`;
		}
		function getRowClass(row, index) {
			const hoverItems = makeArray(props.hover);
			const selectedItems = makeArray(props.selected);
			return {
				"x-clickable": typeof props.onBodyCellClick == "function" || props.selectMode != SelectMode.None,
				"x-hover": hoverItems.includes(row),
				"x-selected": selectedItems.includes(row),
				[row["_htmlclass"]]: row["_htmlclass"]
			};
		}
		function isSortable(col) {
			return col.sortable !== void 0 ? col.sortable : true;
		}
		function onBodyCellClick(item, column) {
			if (typeof props.onBodyCellClick == "function") props.onBodyCellClick(item, column);
			let compareFunc = (item) => item;
			emit("update:selected-field", column);
			emit("update:selected", handleSelection(props.selected, item, props.selectMode, true, compareFunc));
			emit("row-click", {
				item,
				column
			});
		}
		function onBodyCellMouseOver(item, column) {
			emit("update:hover", [item]);
			emit("row-mouse-over", {
				item,
				column
			});
		}
		function onBodyCellMouseOut(item, column) {
			emit("update:hover", []);
			emit("row-mouse-out", {
				item,
				column
			});
		}
		function onHeaderCellClick(field) {
			if (field.sortable === false) return;
			const newSortIndex = fields.value.indexOf(field);
			if (newSortIndex == sortColIndex.value) sortDir.value = -sortDir.value;
			sortColIndex.value = newSortIndex;
		}
		function startDownload() {
			const text = buildCsv();
			const blob = new Blob([text], { type: "text/csv" });
			const link = document.createElement("a");
			link.href = window.URL.createObjectURL(blob);
			link.download = props.downloadFileName;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
		function buildCsv() {
			let result = "";
			for (const field of fields.value) if (field.label) result += htmlConvert(field.label) + ";";
			else result += htmlConvert(field.key) + ";";
			result += "\n";
			for (const item of rowsOrdered.value) {
				for (const field of fields.value) {
					let value = item[field.key];
					if (field.valueFunc) value = field.valueFunc(item);
					result += value;
					result += ";";
				}
				result += "\n";
			}
			return result;
		}
		function htmlConvert(text) {
			let result = text;
			result = result.replace(/&gt;/g, ">");
			result = result.replace(/&lt;/g, "<");
			result = result.replace(/&nbsp;/g, " ");
			return result;
		}
		watch(() => props.triggerDownload, () => {
			startDownload();
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$11, [createElementVNode("table", null, [createElementVNode("thead", null, [createElementVNode("tr", null, [(openBlock(true), createElementBlock(Fragment, null, renderList(fields.value, (col) => {
				return openBlock(), createElementBlock("th", {
					class: normalizeClass(getHeaderCellClass(col)),
					"data-tooltip": getHeaderCellTooltip(col),
					"aria-sort": getHeaderCellAriaSort(col),
					"aria-label": getHeaderCellAriaLabel(col),
					scope: "col",
					role: "columnheader",
					tabindex: "0",
					onClick: ($event) => onHeaderCellClick(col),
					onKeydown: [withKeys(($event) => onHeaderCellClick(col), ["enter"]), withKeys(withModifiers(($event) => onHeaderCellClick(col), ["prevent"]), ["space"])],
					innerHTML: col.label
				}, null, 42, _hoisted_2$7);
			}), 256))])]), createElementVNode("tbody", null, [(openBlock(true), createElementBlock(Fragment, null, renderList(rowsOrdered.value, (row, index) => {
				return openBlock(), createElementBlock("tr", { class: normalizeClass(getRowClass(row, index)) }, [(openBlock(true), createElementBlock(Fragment, null, renderList(fields.value, (field) => {
					return openBlock(), createElementBlock("td", {
						class: normalizeClass(field.htmlClass),
						tabindex: "0",
						onMouseover: ($event) => onBodyCellMouseOver(row, field),
						onMouseout: ($event) => onBodyCellMouseOut(row, field),
						onClick: ($event) => onBodyCellClick(row, field)
					}, [renderSlot(_ctx.$slots, `col-${field.key}`, { item: row }, () => [createElementVNode("div", { innerHTML: getDisplayString(row, field) }, null, 8, _hoisted_4$4)])], 42, _hoisted_3$5);
				}), 256))], 2);
			}), 256))])])]);
		};
	}
});
//#endregion
//#region src/components/SmartTextInput.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$10 = { class: "v-smart-text-input" };
var _hoisted_2$6 = [
	"list",
	"placeholder",
	"data-tooltip",
	"disabled"
];
var _hoisted_3$4 = ["id"];
var _hoisted_4$3 = ["value"];
//#endregion
//#region src/components/SmartTextInput.vue
var SmartTextInput_default = /* @__PURE__ */ defineComponent({
	__name: "SmartTextInput",
	props: {
		suggestionTextFunc: {
			type: Function,
			default: (item) => item
		},
		modelValue: { default: "" },
		placeholder: { default: "" },
		suggestions: { default: () => [] },
		disabled: {
			type: Boolean,
			default: false
		},
		clearOnEnter: {
			type: Boolean,
			default: false
		}
	},
	emits: ["update:modelValue", "enter"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const pValue = ref(props.modelValue);
		const input = ref(null);
		ref(null);
		const hover = ref(false);
		const tooltip = ref("");
		const id = ref("id_" + uuid.v4().toString());
		const dynamicClass = computed(() => {
			return {
				"v-smart-text-input__input": true,
				"v-smart-text-input__input--hover": hover.value
			};
		});
		function onClick(evt) {
			if (!hover.value) return;
			evt.preventDefault();
			pValue.value = "";
		}
		function onKeyDown(evt) {
			if (evt.key === "Enter") {
				if (pValue.value == "") return;
				emit("enter");
				if (props.clearOnEnter) {
					pValue.value = "";
					emit("update:modelValue", pValue.value);
				}
			}
		}
		function onMouseMove(evt) {
			if (!input.value || props.disabled) return;
			hover.value = evt.offsetX > input.value.offsetWidth - 24;
			tooltip.value = hover.value ? "Eingabe löschen" : "";
		}
		function stf(item) {
			return props.suggestionTextFunc(item);
		}
		watch(() => pValue.value, () => {
			emit("update:modelValue", pValue.value);
		});
		watch(() => props.modelValue, () => {
			pValue.value = props.modelValue;
		});
		watch(() => props.suggestions, () => {});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$10, [withDirectives(createElementVNode("input", {
				ref_key: "input",
				ref: input,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => pValue.value = $event),
				list: id.value,
				type: "text",
				class: normalizeClass(dynamicClass.value),
				placeholder: __props.placeholder,
				"data-tooltip": tooltip.value,
				disabled: props.disabled,
				onKeydown: onKeyDown,
				onClick,
				onMousemove: onMouseMove
			}, null, 42, _hoisted_2$6), [[vModelText, pValue.value]]), createElementVNode("datalist", { id: id.value }, [(openBlock(true), createElementBlock(Fragment, null, renderList(props.suggestions, (item) => {
				return openBlock(), createElementBlock("option", { value: stf(item) }, null, 8, _hoisted_4$3);
			}), 256))], 8, _hoisted_3$4)]);
		};
	}
});
//#endregion
//#region src/composables/useElementSize.ts
function useElementSize(target) {
	const size = ref(new Vector2());
	const onResize = () => {
		const el = unref(target);
		if (!el) return;
		const rect = el.getBoundingClientRect();
		size.value = new Vector2(rect.width, rect.height);
	};
	useOnElementResize(target, onResize);
	return size;
}
//#endregion
//#region src/components/SplitPanel.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$9 = ["aria-orientation", "aria-valuenow"];
//#endregion
//#region src/components/SplitPanel.vue
var SplitPanel_default = /* @__PURE__ */ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "SplitPanel",
	props: { ratio: { default: 50 } },
	emits: ["update:ratio"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const containerElem = ref(null);
		const dragHandle = ref(null);
		const { pos: dragPos, isDragging } = useDragPosition(dragHandle);
		const containerSize = useElementSize(containerElem);
		const emit = __emit;
		const _ratio = ref(props.ratio);
		const ratio = computed({
			get() {
				return _ratio.value;
			},
			set(value) {
				value = Math.max(value, 0);
				value = Math.min(value, 100);
				_ratio.value = value;
				emit("update:ratio", _ratio.value);
			}
		});
		const dragHandleStyle = computed(() => {
			const result = {};
			if (landscapeMode.value) {
				result.left = `calc(${ratio.value}%)`;
				result.top = "50%";
			} else {
				result.top = `calc(${ratio.value}%)`;
				result.left = "50%";
			}
			return result;
		});
		const landscapeMode = computed(() => {
			const { x, y } = containerSize.value;
			if (x === 0 && y === 0) return true;
			return x > y;
		});
		function onHandleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
		}
		function onHandleKeyDown(event) {
			let handled = true;
			const step = 5;
			switch (event.key) {
				case "ArrowLeft":
				case "ArrowUp":
					ratio.value -= step;
					break;
				case "ArrowRight":
				case "ArrowDown":
					ratio.value += step;
					break;
				case "Home":
					ratio.value = 0;
					break;
				case "End":
					ratio.value = 100;
					break;
				default: handled = false;
			}
			if (handled) {
				event.preventDefault();
				event.stopPropagation();
			}
		}
		watch(() => dragPos.value, () => {
			if (!isDragging.value) return;
			let newRatio = ratio.value;
			const elem = containerElem.value;
			if (!elem) return;
			const rect = elem.getBoundingClientRect();
			if (landscapeMode.value) newRatio = Math.round((dragPos.value.x - rect.left) / rect.width * 100);
			else newRatio = Math.round((dragPos.value.y - rect.top) / rect.height * 100);
			ratio.value = newRatio;
		});
		watch(() => props.ratio, () => {
			ratio.value = props.ratio;
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "containerElem",
				ref: containerElem,
				class: normalizeClass(["v-split-panel", { portrait: !landscapeMode.value }]),
				style: normalizeStyle({ flexDirection: landscapeMode.value ? "row" : "column" })
			}, [
				createElementVNode("div", {
					class: "v-split-panel__1",
					style: normalizeStyle(`flex: ${ratio.value} 0 0`)
				}, [renderSlot(_ctx.$slots, "panel1", {}, void 0, true)], 4),
				createElementVNode("div", {
					class: "v-split-panel__2",
					style: normalizeStyle(`flex: ${100 - ratio.value} 0 0`)
				}, [renderSlot(_ctx.$slots, "panel2", {}, void 0, true)], 4),
				createElementVNode("div", {
					ref_key: "dragHandle",
					ref: dragHandle,
					class: normalizeClass(["v-split-panel__drag-handle", { "is-dragging": unref(isDragging) }]),
					style: normalizeStyle(dragHandleStyle.value),
					"data-tooltip": "Hier ziehen, um die geteilte Ansicht zu skalieren",
					role: "separator",
					"aria-orientation": landscapeMode.value ? "vertical" : "horizontal",
					"aria-valuenow": Math.round(ratio.value),
					"aria-valuemin": "0",
					"aria-valuemax": "100",
					"aria-label": "Teiler verschieben",
					tabindex: "0",
					onMousedown: onHandleMouseDown,
					onTouchstart: _cache[0] || (_cache[0] = withModifiers(() => {}, ["prevent"])),
					onKeydown: onHandleKeyDown
				}, null, 46, _hoisted_1$9)
			], 6);
		};
	}
}), [["__scopeId", "data-v-794f296d"]]);
//#endregion
//#region src/components/Tab.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$8 = [
	"id",
	"aria-labelledby",
	"tabindex",
	"hidden"
];
//#endregion
//#region src/components/Tab.vue
var Tab_default = /* @__PURE__ */ defineComponent({
	__name: "Tab",
	props: {
		label: {},
		tabKey: {}
	},
	setup(__props) {
		const props = __props;
		const activeTab = inject("tabsGroupActiveTab", ref(null));
		const instanceId = inject("tabsGroupInstanceId", "v-tabs-orphan");
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: normalizeClass(["v-tab", {
					"x-active": unref(activeTab) === props.tabKey,
					"x-inactive": unref(activeTab) !== props.tabKey
				}]),
				role: "tabpanel",
				id: `${unref(instanceId)}-tabpanel-${props.tabKey}`,
				"aria-labelledby": `${unref(instanceId)}-tab-${props.tabKey}`,
				tabindex: unref(activeTab) === props.tabKey ? 0 : -1,
				hidden: unref(activeTab) !== props.tabKey
			}, [renderSlot(_ctx.$slots, "default")], 10, _hoisted_1$8);
		};
	}
});
//#endregion
//#region src/components/TabsGroup.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$7 = { class: "v-tabs-group" };
var _hoisted_2$5 = {
	class: "v-tabs-group__buttons v-list v-list-tabs",
	role: "tablist",
	"aria-orientation": "horizontal"
};
var _hoisted_3$3 = [
	"onClick",
	"onKeydown",
	"id",
	"aria-controls",
	"aria-selected",
	"tabindex"
];
var _hoisted_4$2 = { class: "v-tabs-group__panels" };
var instanceIdCounter = 0;
//#endregion
//#region src/components/TabsGroup.vue
var TabsGroup_default = /* @__PURE__ */ defineComponent({
	__name: "TabsGroup",
	props: { initialTab: {} },
	setup(__props) {
		const slots = useSlots();
		const props = __props;
		const instanceId = `v-tabs-${instanceIdCounter++}`;
		const activeTab = ref(null);
		const tabRefs = ref([]);
		provide("tabsGroupActiveTab", activeTab);
		provide("tabsGroupInstanceId", instanceId);
		const selectedArray = computed({
			get() {
				if (!activeTab.value) return [];
				return tabs.value.filter((t) => t.key === activeTab.value);
			},
			set(newValue) {
				activeTab.value = newValue.length > 0 ? newValue[0].key : null;
			}
		});
		const tabs = computed(() => {
			const defaultSlot = slots.default?.({});
			if (!defaultSlot) return [];
			return defaultSlot.filter((vnode) => vnode.props?.tabKey ?? vnode.props?.["tab-key"]).map((vnode) => ({
				label: vnode.props.label ?? vnode.props.name,
				key: vnode.props.tabKey ?? vnode.props["tab-key"]
			}));
		});
		const onKeyDown = (event, index) => {
			let newIndex = -1;
			if (event.key === "ArrowRight" || event.key === "ArrowDown") newIndex = (index + 1) % tabs.value.length;
			else if (event.key === "ArrowLeft" || event.key === "ArrowUp") newIndex = (index - 1 + tabs.value.length) % tabs.value.length;
			else if (event.key === "Home") newIndex = 0;
			else if (event.key === "End") newIndex = tabs.value.length - 1;
			if (newIndex !== -1) {
				event.preventDefault();
				activeTab.value = tabs.value[newIndex].key;
				nextTick(() => {
					tabRefs.value[newIndex]?.focus();
				});
			}
		};
		onMounted(() => {
			nextTick(() => {
				if (tabs.value.length > 0 && !activeTab.value) {
					const initial = props.initialTab ? tabs.value.find((t) => t.key === props.initialTab) : void 0;
					activeTab.value = (initial ?? tabs.value[0]).key;
				}
			});
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$7, [createElementVNode("ul", _hoisted_2$5, [createVNode(HeadlessList_default, {
				selected: selectedArray.value,
				"onUpdate:selected": _cache[0] || (_cache[0] = ($event) => selectedArray.value = $event),
				items: tabs.value,
				"select-mode": unref(SelectMode).SingleArray,
				"compare-func": (item) => JSON.stringify(item),
				"allow-unselect": false
			}, {
				default: withCtx(({ item, index, isSelected, isHover, onItemClick }) => [createElementVNode("li", {
					class: normalizeClass({
						"v-list__item": true,
						"x-selected": isSelected,
						"x-hover": isHover
					}),
					role: "presentation"
				}, [createElementVNode("div", null, [createElementVNode("button", {
					ref: (el) => tabRefs.value[index] = el,
					onClick: ($event) => onItemClick(item),
					onKeydown: ($event) => onKeyDown($event, index),
					role: "tab",
					id: `${instanceId}-tab-${item.key}`,
					"aria-controls": `${instanceId}-tabpanel-${item.key}`,
					"aria-selected": isSelected,
					tabindex: isSelected ? 0 : -1
				}, toDisplayString(item.label), 41, _hoisted_3$3)])], 2)]),
				_: 1
			}, 8, [
				"selected",
				"items",
				"select-mode",
				"compare-func"
			])]), createElementVNode("div", _hoisted_4$2, [renderSlot(_ctx.$slots, "default")])]);
		};
	}
});
//#endregion
//#region src/util/timeRange.ts
/** Clamp `value` into the inclusive interval [lo, hi]. */
function clamp(value, lo, hi) {
	return Math.max(lo, Math.min(hi, value));
}
/**
* Sort an array of years ascending, removing duplicates. Returns a new array.
*/
function sortYears(years) {
	return Array.from(new Set(years)).sort((a, b) => a - b);
}
/**
* Map a year to its x-pixel coordinate on the track.
*
* When `ctx.years` is present, the year is mapped by its index in the sorted
* list (points are evenly spaced regardless of the gaps between years).
* Otherwise the continuous [min, max] range is used.
*
* Degenerate contexts (no years and max <= min, or innerWidth <= 0) fall back
* to trackStartX.
*/
function yearToX(year, ctx) {
	if (ctx.innerWidth <= 0) return ctx.trackStartX;
	if (ctx.years && ctx.years.length > 0) {
		const index = ctx.years.indexOf(year);
		if (index < 0) return ctx.trackStartX;
		const t = ctx.years.length === 1 ? 0 : index / (ctx.years.length - 1);
		return ctx.trackStartX + t * ctx.innerWidth;
	}
	const span = ctx.max - ctx.min;
	if (span <= 0) return ctx.trackStartX;
	const t = (year - ctx.min) / span;
	return ctx.trackStartX + t * ctx.innerWidth;
}
/**
* Map an x-pixel coordinate to the nearest valid year.
*
* When `ctx.years` is present, the nearest available year (by index) is
* returned. Otherwise the value is rounded to `step` and clamped into
* [min, max]. Degenerate contexts fall back to `min` (or the first year).
*/
function xToYear(x, ctx) {
	if (ctx.innerWidth <= 0) return ctx.years?.[0] ?? ctx.min;
	if (ctx.years && ctx.years.length > 0) {
		const t = (x - ctx.trackStartX) / ctx.innerWidth;
		const index = clamp(Math.round(t * (ctx.years.length - 1)), 0, ctx.years.length - 1);
		return ctx.years[index];
	}
	const span = ctx.max - ctx.min;
	if (span <= 0) return ctx.min;
	const t = (x - ctx.trackStartX) / ctx.innerWidth;
	const year = ctx.min + t * span;
	return clamp(Math.round(year / ctx.step) * ctx.step, ctx.min, ctx.max);
}
/**
* Normalize a (start, end) pair so that:
*  - both values are clamped into [min, max]
*  - start <= end
*  - the span is at least `minRange` years (when possible)
*
* When the span is too small, the `end` handle is pushed forward to satisfy
* `minRange`, but never beyond `max` (the end handle "wins" over the start
* handle). If `start` is too close to `max` to satisfy `minRange`, the range
* is clamped to `max` and `minRange` is not fully met.
*/
function normalizeRange(start, end, opts) {
	const minRange = opts.minRange ?? 0;
	const lo = clamp(start, opts.min, opts.max);
	const hi = clamp(end, opts.min, opts.max);
	const startVal = Math.min(lo, hi);
	const endVal = Math.max(lo, hi);
	return {
		start: startVal,
		end: Math.min(opts.max, Math.max(endVal, startVal + minRange))
	};
}
/**
* Compute adaptive tick marks for a horizontal year axis.
*
* Simple and robust rules:
*  - If every year fits within `minLabelSpacingPx`, label every year.
*  - Otherwise fall back to labeling only EVEN years (never a mixed
*    even/odd set of labels) so the axis always looks consistent.
*  - When even years also do not fit, drop unlabeled minor ticks instead of
*    producing an uneven/odd mix of labels.
*  - The min and max endpoints stay ticked so the range is fully delimited;
*    endpoints that fall on an odd year receive a label too.
*/
function ticksForRange(widthPx, min, max, minLabelSpacingPx = 40) {
	const span = max - min;
	if (span <= 0 || widthPx <= 0) return [];
	if (widthPx / span >= minLabelSpacingPx) {
		const result = [];
		for (let year = min; year <= max; year += 1) result.push({
			year,
			labeled: true
		});
		return result;
	}
	const result = [];
	for (let year = min; year <= max; year += 1) {
		const isEven = year % 2 === 0;
		const isEndpoint = year === min || year === max;
		result.push({
			year,
			labeled: isEven || isEndpoint
		});
	}
	return result;
}
/**
* Compute tick marks for an explicit list of selectable years.
*
* Each available year gets a tick. Labels are shown for every year when they
* fit within `minLabelSpacingPx`; otherwise only the first and last years are
* labeled (the endpoints always delimit the range).
*/
function ticksForYears(widthPx, years, minLabelSpacingPx = 40) {
	if (years.length === 0 || widthPx <= 0) return [];
	const pxPerPoint = widthPx / (years.length - 1);
	const labelAll = years.length === 1 || pxPerPoint >= minLabelSpacingPx;
	return years.map((year, index) => ({
		year,
		labeled: labelAll || index === 0 || index === years.length - 1
	}));
}
//#endregion
//#region src/components/timeSliders/useTimelineSlider.ts
/**
* Shared SVG layout constants for the timeline slider components
* (`TimeRangeSelector` and `TimePointSelector`). 1 unit == 1 pixel, because the
* SVG `viewBox` is bound to the measured pixel width of the container.
*/
var TIMELINE_GEOMETRY = {
	SVG_HEIGHT: 90,
	TRACK_Y: 44,
	BAND_HALF_HEIGHT: 5,
	TICK_HALF_HEIGHT: 4,
	TICK_LABEL_OFFSET_X: 4,
	TICK_LABEL_OFFSET_Y: 32,
	/** Minimum horizontal space per year (px) before all year labels are shown. */
	TICK_LABEL_MIN_SPACING: 30,
	VALUE_LABEL_OFFSET_Y: 16,
	/** Approx. value-label width + spacing buffer for overlap detection. */
	VALUE_LABEL_OVERLAP_BUFFER: 34,
	HANDLE_RADIUS: 9,
	HIT_AREA_RADIUS: 15,
	HORIZONTAL_PADDING: 22
};
/**
* Shared interaction logic for the timeline sliders: container measurement,
* year <-> pixel mapping, adaptive ticks, mouse/touch dragging (with the
* Firefox-safe pointer-X extraction) and keyboard navigation.
*
* The value semantics (range vs. single point, ordering constraints, minRange)
* are intentionally left to the caller via `getCurrent` / `onMove`.
*/
function useTimelineSlider(opts) {
	const containerSize = useElementSize(opts.containerRef);
	/** Which handle is currently being dragged. */
	const activeHandle = ref(null);
	const isAnyDragging = computed(() => activeHandle.value != null);
	/**
	* Whether the value changed during the current drag. Reset on drag start
	* and set whenever a move actually changes the value, so the drag-end
	* commit can skip no-op emits.
	*/
	let didChange = false;
	/**
	* Accumulated sub-step remainder (in years) during a band drag. The band
	* moves in whole steps; leftover fractional movement is carried over to
	* the next pointer move so the drag feels smooth and the cursor does not
	* drift relative to the band.
	*/
	const bandAccumulator = ref(0);
	/** ClientX of the last pointer move during a band drag. */
	const lastPointerX = ref(null);
	useEventListener(document, "pointermove", onPointerMove);
	useEventListener(document, "pointerup", endDrag);
	useEventListener(document, "pointercancel", endDrag);
	useEventListener(document, "touchmove", onPointerMove);
	useEventListener(document, "touchend", endDrag);
	useEventListener(document, "touchcancel", endDrag);
	/**
	* Persist the current value when appropriate: immediately for keyboard
	* moves, continuously during a drag when `emitOnDrag` is enabled, and
	* otherwise only once the drag ends (see the `isAnyDragging` watcher).
	*/
	function maybeCommit() {
		if (!isAnyDragging.value || opts.emitOnDrag()) opts.onCommit();
	}
	watch(isAnyDragging, (dragging) => {
		if (!dragging && didChange) opts.onCommit();
	});
	const svgWidth = computed(() => Math.max(0, containerSize.value.x));
	const trackStartX = computed(() => TIMELINE_GEOMETRY.HORIZONTAL_PADDING);
	const trackEndX = computed(() => Math.max(trackStartX.value, svgWidth.value - TIMELINE_GEOMETRY.HORIZONTAL_PADDING));
	const innerWidth = computed(() => Math.max(0, trackEndX.value - trackStartX.value));
	/** Sorted list of available years (empty when not using discrete years). */
	const years = computed(() => sortYears(opts.getYears?.() ?? []));
	function makeContext() {
		return {
			min: opts.min(),
			max: opts.max(),
			trackStartX: trackStartX.value,
			innerWidth: innerWidth.value,
			step: opts.step(),
			years: years.value.length > 0 ? years.value : void 0
		};
	}
	function yearToXLocal(year) {
		return yearToX(year, makeContext());
	}
	function xToYearLocal(x) {
		return xToYear(x, makeContext());
	}
	/**
	* Adaptive tick marks: when discrete years are provided, one tick per
	* available year; otherwise all-year labels when they fit, else even years
	* only.
	*/
	const ticks = computed(() => years.value.length > 0 ? ticksForYears(innerWidth.value, years.value, TIMELINE_GEOMETRY.TICK_LABEL_MIN_SPACING) : ticksForRange(innerWidth.value, opts.min(), opts.max(), TIMELINE_GEOMETRY.TICK_LABEL_MIN_SPACING));
	/**
	* Resolve the clientX of a mouse or touch event.
	*
	* Uses feature detection on the event's `touches` property rather than
	* `event instanceof TouchEvent`, because some browsers (e.g. desktop Firefox)
	* do not expose a global `TouchEvent` constructor, which would throw a
	* `ReferenceError` when referenced.
	*/
	function getPointerX(event) {
		const touchEvent = event;
		if (touchEvent.touches && touchEvent.touches.length > 0) return touchEvent.touches[0].clientX;
		if (touchEvent.changedTouches && touchEvent.changedTouches.length > 0) return touchEvent.changedTouches[0].clientX;
		return event.clientX;
	}
	/** Convert a clientX to a year and move the currently active handle. */
	function applyDragPosition(clientX) {
		const rect = opts.containerRef.value?.getBoundingClientRect();
		if (!rect || activeHandle.value == null) return;
		const year = xToYearLocal(clientX - rect.left);
		didChange = opts.onMove(year, activeHandle.value) || didChange;
		maybeCommit();
	}
	/**
	* Convert a clientX to a year delta from the band drag start and shift the
	* range. The delta is accumulated in pixels and emitted in whole `step`
	* increments, carrying the remainder so the band moves cleanly by the step
	* size without the cursor drifting away from it.
	*/
	function applyBandDragPosition(clientX) {
		if (!opts.containerRef.value?.getBoundingClientRect() || activeHandle.value !== "band") return;
		const ctx = makeContext();
		if (ctx.innerWidth <= 0) return;
		bandAccumulator.value += clientX - lastPointerX.value;
		lastPointerX.value = clientX;
		if (ctx.years && ctx.years.length > 0) {
			const pxPerPoint = ctx.innerWidth / (ctx.years.length - 1);
			const accumulatedPoints = bandAccumulator.value / pxPerPoint;
			const wholeSteps = Math.trunc(accumulatedPoints);
			if (wholeSteps !== 0) {
				bandAccumulator.value -= wholeSteps * pxPerPoint;
				didChange = (opts.onBandMove?.(wholeSteps) ?? false) || didChange;
				if (opts.emitOnDrag()) opts.onCommit();
			}
			return;
		}
		const pxPerYear = ctx.innerWidth / (ctx.max - ctx.min);
		const accumulatedYears = bandAccumulator.value / pxPerYear;
		const wholeSteps = Math.trunc(accumulatedYears / ctx.step);
		if (wholeSteps !== 0) {
			bandAccumulator.value -= wholeSteps * ctx.step * pxPerYear;
			didChange = (opts.onBandMove?.(wholeSteps * ctx.step) ?? false) || didChange;
			if (opts.emitOnDrag()) opts.onCommit();
		}
	}
	/** Begin dragging a handle (bound to `mousedown`/`touchstart` on the handle). */
	function onHandlePointerDown(handle, event) {
		if (opts.disabled()) return;
		event.preventDefault();
		event.stopPropagation();
		activeHandle.value = handle;
		didChange = false;
		if (handle === "band") {
			bandAccumulator.value = 0;
			lastPointerX.value = getPointerX(event);
			return;
		}
		applyDragPosition(getPointerX(event));
	}
	function onPointerMove(event) {
		if (activeHandle.value == null || opts.disabled()) return;
		if (activeHandle.value === "band") {
			applyBandDragPosition(getPointerX(event));
			return;
		}
		applyDragPosition(getPointerX(event));
	}
	function endDrag() {
		activeHandle.value = null;
		bandAccumulator.value = 0;
		lastPointerX.value = null;
	}
	function onHandleKeyDown(handle, event) {
		if (opts.disabled()) return;
		let handled = true;
		const current = opts.getCurrent(handle);
		const min = opts.min();
		const max = opts.max();
		const step = opts.step();
		const pageStep = Math.max(step, Math.round((max - min) / 10));
		let target = current;
		if (years.value.length > 0) {
			const index = years.value.indexOf(current);
			const lastIndex = years.value.length - 1;
			const pageIndexStep = Math.max(1, Math.round(lastIndex / 10));
			switch (event.key) {
				case "ArrowLeft":
				case "ArrowDown":
					target = years.value[Math.max(0, index - 1)];
					break;
				case "ArrowRight":
				case "ArrowUp":
					target = years.value[Math.min(lastIndex, index + 1)];
					break;
				case "PageDown":
					target = years.value[Math.max(0, index - pageIndexStep)];
					break;
				case "PageUp":
					target = years.value[Math.min(lastIndex, index + pageIndexStep)];
					break;
				case "Home":
					target = years.value[0];
					break;
				case "End":
					target = years.value[lastIndex];
					break;
				default: handled = false;
			}
		} else switch (event.key) {
			case "ArrowLeft":
			case "ArrowDown":
				target = current - step;
				break;
			case "ArrowRight":
			case "ArrowUp":
				target = current + step;
				break;
			case "PageDown":
				target = current - pageStep;
				break;
			case "PageUp":
				target = current + pageStep;
				break;
			case "Home":
				target = min;
				break;
			case "End":
				target = max;
				break;
			default: handled = false;
		}
		if (handled) {
			opts.onMove(target, handle);
			maybeCommit();
			event.preventDefault();
			event.stopPropagation();
		}
	}
	return {
		containerSize,
		svgWidth,
		trackStartX,
		trackEndX,
		innerWidth,
		activeHandle,
		isAnyDragging,
		years,
		yearToX: yearToXLocal,
		ticks,
		onHandlePointerDown,
		onHandleKeyDown
	};
}
//#endregion
//#region src/components/timeSliders/TimelineTicks.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$6 = [
	"x1",
	"y1",
	"x2",
	"y2"
];
var _hoisted_2$4 = [
	"x",
	"y",
	"transform"
];
//#endregion
//#region src/components/timeSliders/TimelineTicks.vue
var TimelineTicks_default = /* @__PURE__ */ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "TimelineTicks",
	props: {
		ticks: {},
		yearToX: { type: Function }
	},
	setup(__props) {
		const props = __props;
		/** Layout constants (shared with the timeline slider components). */
		const G = TIMELINE_GEOMETRY;
		return (_ctx, _cache) => {
			return openBlock(true), createElementBlock(Fragment, null, renderList(props.ticks, (tick) => {
				return openBlock(), createElementBlock("g", { key: tick.year }, [createElementVNode("line", {
					x1: props.yearToX(tick.year),
					y1: unref(G).TRACK_Y - unref(G).TICK_HALF_HEIGHT,
					x2: props.yearToX(tick.year),
					y2: unref(G).TRACK_Y + unref(G).TICK_HALF_HEIGHT,
					class: normalizeClass(["v-timeline-ticks__tick", { "is-labeled": tick.labeled }])
				}, null, 10, _hoisted_1$6), tick.labeled ? (openBlock(), createElementBlock("text", {
					key: 0,
					x: props.yearToX(tick.year) + unref(G).TICK_LABEL_OFFSET_X,
					y: unref(G).TRACK_Y + unref(G).TICK_LABEL_OFFSET_Y,
					transform: `rotate(45 ${props.yearToX(tick.year) + unref(G).TICK_LABEL_OFFSET_X} ${unref(G).TRACK_Y + unref(G).TICK_LABEL_OFFSET_Y})`,
					class: "v-timeline-ticks__tick-label",
					"text-anchor": "middle"
				}, toDisplayString(tick.year), 9, _hoisted_2$4)) : createCommentVNode("", true)]);
			}), 128);
		};
	}
}), [["__scopeId", "data-v-8c885820"]]);
//#endregion
//#region src/components/timeSliders/TimelineHandle.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$5 = [
	"aria-label",
	"aria-valuemin",
	"aria-valuemax",
	"aria-valuenow",
	"aria-valuetext",
	"aria-disabled"
];
var _hoisted_2$3 = [
	"cx",
	"cy",
	"r"
];
var _hoisted_3$2 = [
	"cx",
	"cy",
	"r"
];
var _hoisted_4$1 = ["x", "y"];
//#endregion
//#region src/components/timeSliders/TimelineHandle.vue
var TimelineHandle_default = /* @__PURE__ */ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "TimelineHandle",
	props: {
		handle: {},
		x: {},
		year: {},
		labelY: {},
		min: {},
		max: {},
		disabled: { type: Boolean },
		label: {},
		isDragging: { type: Boolean },
		dragActive: { type: Boolean },
		onPointerDown: { type: Function },
		onKeyDown: { type: Function }
	},
	setup(__props) {
		/** Layout constants (shared with the timeline slider components). */
		const G = TIMELINE_GEOMETRY;
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("g", {
				class: normalizeClass(["v-timeline-handle", {
					"is-dragging": __props.isDragging,
					"is-drag-active": __props.dragActive
				}]),
				role: "slider",
				tabindex: "0",
				"aria-label": __props.label,
				"aria-orientation": "horizontal",
				"aria-valuemin": __props.min,
				"aria-valuemax": __props.max,
				"aria-valuenow": __props.year,
				"aria-valuetext": `${__props.label} ${__props.year}`,
				"aria-disabled": __props.disabled,
				onMousedown: _cache[0] || (_cache[0] = withModifiers(($event) => __props.onPointerDown(__props.handle, $event), ["prevent"])),
				onTouchstart: _cache[1] || (_cache[1] = withModifiers(($event) => __props.onPointerDown(__props.handle, $event), ["prevent"])),
				onKeydown: _cache[2] || (_cache[2] = ($event) => __props.onKeyDown(__props.handle, $event))
			}, [
				createElementVNode("circle", {
					cx: __props.x,
					cy: unref(G).TRACK_Y,
					r: unref(G).HANDLE_RADIUS,
					class: "v-timeline-handle__dot"
				}, null, 8, _hoisted_2$3),
				createElementVNode("circle", {
					cx: __props.x,
					cy: unref(G).TRACK_Y,
					r: unref(G).HIT_AREA_RADIUS,
					class: "v-timeline-handle__hit-area"
				}, null, 8, _hoisted_3$2),
				createElementVNode("text", {
					x: __props.x,
					y: __props.labelY,
					class: "v-timeline-handle__value-label",
					"text-anchor": "middle"
				}, toDisplayString(__props.year), 9, _hoisted_4$1)
			], 42, _hoisted_1$5);
		};
	}
}), [["__scopeId", "data-v-a5e33fbe"]]);
//#endregion
//#region src/components/timeSliders/TimeRangeSelector.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$4 = ["aria-label"];
var _hoisted_2$2 = [
	"width",
	"height",
	"viewBox"
];
var _hoisted_3$1 = [
	"x1",
	"y1",
	"x2",
	"y2"
];
var _hoisted_4 = [
	"x",
	"y",
	"width",
	"height",
	"aria-label",
	"aria-valuemin",
	"aria-valuemax",
	"aria-valuenow",
	"aria-valuetext",
	"aria-disabled"
];
//#endregion
//#region src/components/timeSliders/TimeRangeSelector.vue
var TimeRangeSelector_default = /* @__PURE__ */ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "TimeRangeSelector",
	props: {
		modelValue: { default: () => ({
			start: 1900,
			end: 2025
		}) },
		min: { default: 1900 },
		max: { default: 2025 },
		step: { default: 1 },
		minRange: { default: 0 },
		years: { default: () => [] },
		disabled: {
			type: Boolean,
			default: false
		},
		emitOnDrag: {
			type: Boolean,
			default: false
		},
		ariaLabel: { default: "Zeitraum-Auswahl" },
		ariaLabelStart: { default: "Startjahr" },
		ariaLabelEnd: { default: "Endjahr" },
		ariaLabelBand: { default: "Zeitraum verschieben" }
	},
	emits: ["update:modelValue"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		/** Layout constants (shared with TimePointSelector). */
		const G = TIMELINE_GEOMETRY;
		const containerElem = ref(null);
		/**
		* Local draft of the selected range. While a handle is being dragged the
		* handles move here, but the parent is only notified once the drag ends.
		*/
		const draftRange = ref({
			start: props.min,
			end: props.max
		});
		const startYear = computed(() => draftRange.value.start);
		const endYear = computed(() => draftRange.value.end);
		/** Index of a year within the sorted available years, or -1 when not present. */
		function yearIndex(year) {
			return props.years.indexOf(year);
		}
		/** Snap a value to the nearest available year (when discrete years are set). */
		function snapToAvailable(value) {
			if (props.years.length === 0) return value;
			let closest = props.years[0];
			let closestDistance = Infinity;
			for (const y of props.years) {
				const distance = Math.abs(y - value);
				if (distance < closestDistance) {
					closest = y;
					closestDistance = distance;
				}
			}
			return closest;
		}
		function setStart(year) {
			if (props.years.length > 0) {
				const snapped = snapToAvailable(year);
				const maxStartIndex = Math.max(0, yearIndex(endYear.value) - props.minRange);
				const clamped = props.years[Math.min(yearIndex(snapped), maxStartIndex)];
				if (clamped === startYear.value) return false;
				draftRange.value = {
					start: clamped,
					end: endYear.value
				};
				return true;
			}
			const clamped = clamp(year, props.min, endYear.value - props.minRange);
			if (clamped === startYear.value) return false;
			draftRange.value = {
				start: clamped,
				end: endYear.value
			};
			return true;
		}
		function setEnd(year) {
			if (props.years.length > 0) {
				const snapped = snapToAvailable(year);
				const minEndIndex = Math.min(props.years.length - 1, yearIndex(startYear.value) + props.minRange);
				const clamped = props.years[Math.max(yearIndex(snapped), minEndIndex)];
				if (clamped === endYear.value) return false;
				draftRange.value = {
					start: startYear.value,
					end: clamped
				};
				return true;
			}
			const clamped = clamp(year, startYear.value + props.minRange, props.max);
			if (clamped === endYear.value) return false;
			draftRange.value = {
				start: startYear.value,
				end: clamped
			};
			return true;
		}
		/**
		* Shift the whole selected range by `deltaYears`, keeping the span constant.
		* The handles act as boundaries: the range is clamped so it never extends
		* outside [min, max] (or the first/last available year when discrete years
		* are set). Returns whether the range actually moved.
		*/
		function shiftRange(deltaYears) {
			if (props.years.length > 0) {
				const startIndex = yearIndex(startYear.value);
				const endIndex = yearIndex(endYear.value);
				const span = endIndex - startIndex;
				let newStartIndex = startIndex + deltaYears;
				let newEndIndex = endIndex + deltaYears;
				if (newStartIndex < 0) {
					newStartIndex = 0;
					newEndIndex = newStartIndex + span;
				}
				if (newEndIndex > props.years.length - 1) {
					newEndIndex = props.years.length - 1;
					newStartIndex = newEndIndex - span;
				}
				const newStart = props.years[newStartIndex];
				const newEnd = props.years[newEndIndex];
				if (newStart === startYear.value && newEnd === endYear.value) return false;
				draftRange.value = {
					start: newStart,
					end: newEnd
				};
				return true;
			}
			const span = endYear.value - startYear.value;
			let newStart = startYear.value + deltaYears;
			let newEnd = endYear.value + deltaYears;
			if (newStart < props.min) {
				newStart = props.min;
				newEnd = newStart + span;
			}
			if (newEnd > props.max) {
				newEnd = props.max;
				newStart = newEnd - span;
			}
			if (newStart === startYear.value && newEnd === endYear.value) return false;
			draftRange.value = {
				start: newStart,
				end: newEnd
			};
			return true;
		}
		const { svgWidth, trackStartX, trackEndX, activeHandle, isAnyDragging, yearToX, ticks, onHandlePointerDown, onHandleKeyDown } = useTimelineSlider({
			containerRef: containerElem,
			min: () => props.min,
			max: () => props.max,
			step: () => props.step,
			getYears: () => props.years,
			disabled: () => props.disabled,
			getCurrent: (handle) => {
				switch (handle) {
					case "start": return startYear.value;
					case "end": return endYear.value;
					default: return startYear.value;
				}
			},
			onMove: (year, handle) => {
				switch (handle) {
					case "start": return setStart(year);
					case "end": return setEnd(year);
					default: return false;
				}
			},
			onBandMove: (deltaYears) => shiftRange(deltaYears),
			emitOnDrag: () => props.emitOnDrag,
			onCommit: () => emit("update:modelValue", {
				start: startYear.value,
				end: endYear.value
			})
		});
		watch(() => props.modelValue, (val) => {
			if (isAnyDragging.value) return;
			draftRange.value = {
				start: clamp(snapToAvailable(val.start), props.min, props.max),
				end: clamp(snapToAvailable(val.end), props.min, props.max)
			};
		}, { immediate: true });
		/**
		* Keyboard navigation for the band: move the whole selected range by the
		* step size (or a larger page step), with Home/End jumping to the track
		* bounds. Behaves like the handles' keyboard interaction.
		*/
		function onBandKeyDown(event) {
			if (props.disabled) return;
			const step = props.step;
			const pageStep = Math.max(step, Math.round((props.max - props.min) / 10));
			let delta = 0;
			if (props.years.length > 0) {
				const lastIndex = props.years.length - 1;
				const pageIndexStep = Math.max(1, Math.round(lastIndex / 10));
				switch (event.key) {
					case "ArrowLeft":
					case "ArrowDown":
						delta = -1;
						break;
					case "ArrowRight":
					case "ArrowUp":
						delta = 1;
						break;
					case "PageDown":
						delta = -pageIndexStep;
						break;
					case "PageUp":
						delta = pageIndexStep;
						break;
					case "Home":
						delta = -yearIndex(startYear.value);
						break;
					case "End":
						delta = lastIndex - yearIndex(endYear.value);
						break;
					default: return;
				}
			} else switch (event.key) {
				case "ArrowLeft":
				case "ArrowDown":
					delta = -step;
					break;
				case "ArrowRight":
				case "ArrowUp":
					delta = step;
					break;
				case "PageDown":
					delta = -pageStep;
					break;
				case "PageUp":
					delta = pageStep;
					break;
				case "Home":
					delta = props.min - startYear.value;
					break;
				case "End":
					delta = props.max - endYear.value;
					break;
				default: return;
			}
			shiftRange(delta);
			emit("update:modelValue", {
				start: startYear.value,
				end: endYear.value
			});
			event.preventDefault();
			event.stopPropagation();
		}
		const startX = computed(() => yearToX(startYear.value));
		const endX = computed(() => yearToX(endYear.value));
		/**
		* Y-coordinate of the start-handle value label.
		* When the two labels would overlap (handles close together), the start label
		* is raised so they are stacked vertically instead of colliding.
		*/
		const startLabelY = computed(() => {
			const baseY = G.TRACK_Y - G.VALUE_LABEL_OFFSET_Y;
			return Math.abs(startX.value - endX.value) < G.VALUE_LABEL_OVERLAP_BUFFER ? baseY - G.VALUE_LABEL_OFFSET_Y : baseY;
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "containerElem",
				ref: containerElem,
				class: normalizeClass(["v-time-range-selector", { "is-disabled": props.disabled }]),
				"aria-label": props.ariaLabel,
				role: "group"
			}, [unref(svgWidth) > 0 ? (openBlock(), createElementBlock("svg", {
				key: 0,
				width: unref(svgWidth),
				height: unref(G).SVG_HEIGHT,
				viewBox: `0 0 ${unref(svgWidth)} ${unref(G).SVG_HEIGHT}`,
				class: normalizeClass(["v-time-range-selector__svg", { "is-dragging": unref(isAnyDragging) }])
			}, [
				createElementVNode("line", {
					x1: unref(trackStartX),
					y1: unref(G).TRACK_Y,
					x2: unref(trackEndX),
					y2: unref(G).TRACK_Y,
					class: "v-time-range-selector__track"
				}, null, 8, _hoisted_3$1),
				createElementVNode("rect", {
					x: startX.value,
					y: unref(G).TRACK_Y - unref(G).BAND_HALF_HEIGHT,
					width: Math.max(0, endX.value - startX.value),
					height: unref(G).BAND_HALF_HEIGHT * 2,
					class: normalizeClass(["v-time-range-selector__band", { "is-dragging": unref(activeHandle) === "band" }]),
					role: "slider",
					tabindex: "0",
					"aria-label": props.ariaLabelBand,
					"aria-orientation": "horizontal",
					"aria-valuemin": props.min,
					"aria-valuemax": props.max,
					"aria-valuenow": startYear.value,
					"aria-valuetext": `${props.ariaLabelBand} ${startYear.value} – ${endYear.value}`,
					"aria-disabled": props.disabled,
					onMousedown: _cache[0] || (_cache[0] = withModifiers(($event) => unref(onHandlePointerDown)("band", $event), ["prevent"])),
					onTouchstart: _cache[1] || (_cache[1] = withModifiers(($event) => unref(onHandlePointerDown)("band", $event), ["prevent"])),
					onKeydown: _cache[2] || (_cache[2] = ($event) => onBandKeyDown($event))
				}, null, 42, _hoisted_4),
				createVNode(TimelineTicks_default, {
					ticks: unref(ticks),
					"year-to-x": unref(yearToX)
				}, null, 8, ["ticks", "year-to-x"]),
				createVNode(TimelineHandle_default, {
					handle: "start",
					x: startX.value,
					year: startYear.value,
					"label-y": startLabelY.value,
					min: props.min,
					max: props.max,
					disabled: props.disabled,
					label: props.ariaLabelStart,
					"is-dragging": unref(activeHandle) === "start",
					"drag-active": unref(isAnyDragging),
					"on-pointer-down": unref(onHandlePointerDown),
					"on-key-down": unref(onHandleKeyDown)
				}, null, 8, [
					"x",
					"year",
					"label-y",
					"min",
					"max",
					"disabled",
					"label",
					"is-dragging",
					"drag-active",
					"on-pointer-down",
					"on-key-down"
				]),
				createVNode(TimelineHandle_default, {
					handle: "end",
					x: endX.value,
					year: endYear.value,
					"label-y": unref(G).TRACK_Y - unref(G).VALUE_LABEL_OFFSET_Y,
					min: props.min,
					max: props.max,
					disabled: props.disabled,
					label: props.ariaLabelEnd,
					"is-dragging": unref(activeHandle) === "end",
					"drag-active": unref(isAnyDragging),
					"on-pointer-down": unref(onHandlePointerDown),
					"on-key-down": unref(onHandleKeyDown)
				}, null, 8, [
					"x",
					"year",
					"label-y",
					"min",
					"max",
					"disabled",
					"label",
					"is-dragging",
					"drag-active",
					"on-pointer-down",
					"on-key-down"
				])
			], 10, _hoisted_2$2)) : createCommentVNode("", true)], 10, _hoisted_1$4);
		};
	}
}), [["__scopeId", "data-v-d9096e4f"]]);
//#endregion
//#region src/components/timeSliders/TimePointSelector.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$3 = ["aria-label"];
var _hoisted_2$1 = [
	"width",
	"height",
	"viewBox"
];
var _hoisted_3 = [
	"x1",
	"y1",
	"x2",
	"y2"
];
//#endregion
//#region src/components/timeSliders/TimePointSelector.vue
var TimePointSelector_default = /* @__PURE__ */ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "TimePointSelector",
	props: {
		modelValue: { default: 2010 },
		min: { default: 1900 },
		max: { default: 2025 },
		step: { default: 1 },
		years: { default: () => [] },
		disabled: {
			type: Boolean,
			default: false
		},
		emitOnDrag: {
			type: Boolean,
			default: false
		},
		ariaLabel: { default: "Zeitpunkt-Auswahl" },
		ariaLabelPoint: { default: "Jahr" }
	},
	emits: ["update:modelValue"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		/** Layout constants (shared with TimeRangeSelector). */
		const G = TIMELINE_GEOMETRY;
		const containerElem = ref(null);
		/**
		* Local draft of the selected year. While the handle is being dragged the
		* marker moves here, but the parent is only notified once the drag ends.
		*/
		const draftYear = ref(props.min);
		const year = computed(() => draftYear.value);
		/** Snap a value to the nearest available year (when discrete years are set). */
		function snapToAvailable(value) {
			if (props.years.length === 0) return value;
			let closest = props.years[0];
			let closestDistance = Infinity;
			for (const y of props.years) {
				const distance = Math.abs(y - value);
				if (distance < closestDistance) {
					closest = y;
					closestDistance = distance;
				}
			}
			return closest;
		}
		function setYear(value) {
			const clamped = clamp(snapToAvailable(value), props.min, props.max);
			if (clamped === year.value) return false;
			draftYear.value = clamped;
			return true;
		}
		const { svgWidth, trackStartX, trackEndX, activeHandle, isAnyDragging, yearToX, ticks, onHandlePointerDown, onHandleKeyDown } = useTimelineSlider({
			containerRef: containerElem,
			min: () => props.min,
			max: () => props.max,
			step: () => props.step,
			getYears: () => props.years,
			disabled: () => props.disabled,
			getCurrent: () => year.value,
			onMove: (value) => setYear(value),
			emitOnDrag: () => props.emitOnDrag,
			onCommit: () => emit("update:modelValue", year.value)
		});
		watch(() => props.modelValue, (val) => {
			if (isAnyDragging.value) return;
			draftYear.value = clamp(snapToAvailable(val), props.min, props.max);
		}, { immediate: true });
		const pointX = computed(() => yearToX(year.value));
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "containerElem",
				ref: containerElem,
				class: normalizeClass(["v-time-point-selector", { "is-disabled": props.disabled }]),
				"aria-label": props.ariaLabel,
				role: "group"
			}, [unref(svgWidth) > 0 ? (openBlock(), createElementBlock("svg", {
				key: 0,
				width: unref(svgWidth),
				height: unref(G).SVG_HEIGHT,
				viewBox: `0 0 ${unref(svgWidth)} ${unref(G).SVG_HEIGHT}`,
				class: normalizeClass(["v-time-point-selector__svg", { "is-dragging": unref(isAnyDragging) }])
			}, [
				createElementVNode("line", {
					x1: unref(trackStartX),
					y1: unref(G).TRACK_Y,
					x2: unref(trackEndX),
					y2: unref(G).TRACK_Y,
					class: "v-time-point-selector__track"
				}, null, 8, _hoisted_3),
				createVNode(TimelineTicks_default, {
					ticks: unref(ticks),
					"year-to-x": unref(yearToX)
				}, null, 8, ["ticks", "year-to-x"]),
				createVNode(TimelineHandle_default, {
					handle: "point",
					x: pointX.value,
					year: year.value,
					"label-y": unref(G).TRACK_Y - unref(G).VALUE_LABEL_OFFSET_Y,
					min: props.min,
					max: props.max,
					disabled: props.disabled,
					label: props.ariaLabelPoint,
					"is-dragging": unref(activeHandle) === "point",
					"drag-active": unref(isAnyDragging),
					"on-pointer-down": unref(onHandlePointerDown),
					"on-key-down": unref(onHandleKeyDown)
				}, null, 8, [
					"x",
					"year",
					"label-y",
					"min",
					"max",
					"disabled",
					"label",
					"is-dragging",
					"drag-active",
					"on-pointer-down",
					"on-key-down"
				])
			], 10, _hoisted_2$1)) : createCommentVNode("", true)], 10, _hoisted_1$3);
		};
	}
}), [["__scopeId", "data-v-cd21433b"]]);
//#endregion
//#region src/composables/useMousePos.ts
function useMousePos(target, absolute) {
	const mousePos = ref(new Vector2());
	const onMouseMove = (evt) => {
		if (absolute) mousePos.value = new Vector2(evt.clientX, evt.clientY);
		else mousePos.value = new Vector2(evt.offsetX, evt.offsetY);
	};
	const onTouchMove = (evt) => {
		const touch1 = evt.touches[0];
		mousePos.value = new Vector2(touch1.pageX, touch1.pageY);
	};
	useEventListener(target, "mousemove", onMouseMove);
	useEventListener(target, "touchmove", onTouchMove);
	return mousePos;
}
//#endregion
//#region src/composables/useIntervalTimer.ts
function useIntervalTimer(callback, interval_ms) {
	let handle = 0;
	onMounted(() => {
		handle = window.setInterval(callback, interval_ms);
	});
	onBeforeUnmount(() => {
		window.clearInterval(handle);
	});
}
//#endregion
//#region src/components/Tooltip.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$2 = ["innerHTML"];
//#endregion
//#region src/components/Tooltip.vue
var Tooltip_default = /* @__PURE__ */ defineComponent({
	__name: "Tooltip",
	props: {
		enableOnTouch: {
			type: Boolean,
			default: true
		},
		dataPropName: { default: "data-tooltip" },
		timeoutHideMs: { default: 100 },
		timeoutShowMs: { default: 400 }
	},
	setup(__props) {
		const props = __props;
		const mousePos = useMousePos(document, true);
		const showTooltip = ref(false);
		const tooltipText = ref("");
		const rootElem = ref(null);
		let showTimeoutHandle = -1;
		let hideTimeoutHandle = -1;
		const dynamicStyle = computed(() => {
			const tooltipElement = rootElem.value;
			if (tooltipElement == null || mousePos.value == null) return;
			let offset_x = 0;
			let offset_y = 0;
			const margin_x = tooltipElement.offsetWidth / 2 + 10;
			if (mousePos.value.x < margin_x) offset_x = 10;
			else if (mousePos.value.x > document.body.offsetWidth - margin_x) offset_x = -tooltipElement.offsetWidth - 10;
			else offset_x = -tooltipElement.offsetWidth / 2;
			if (mousePos.value.y < tooltipElement.offsetHeight + 20) offset_y = 20;
			else offset_y = -tooltipElement.offsetHeight - 10;
			const left = mousePos.value.x + offset_x;
			const top = mousePos.value.y + offset_y;
			return {
				"left": left + "px",
				"top": top + "px",
				"opacity": showTooltip.value ? "1" : "0"
			};
		});
		function handleElement() {
			let element = document.elementFromPoint(mousePos.value.x, mousePos.value.y);
			if (element == null) return;
			let text = null;
			while (element.parentElement != null) {
				text = element.getAttribute(props.dataPropName);
				if (text != null) break;
				element = element.parentElement;
			}
			if (text == null || text == "" || element.getAttribute("disabled") != null) {
				hide();
				return;
			}
			tooltipText.value = text;
			show();
		}
		function hide() {
			window.clearTimeout(showTimeoutHandle);
			showTimeoutHandle = -1;
			if (hideTimeoutHandle == -1) hideTimeoutHandle = window.setTimeout(() => {
				showTooltip.value = false;
			}, props.timeoutHideMs);
		}
		function show() {
			window.clearTimeout(hideTimeoutHandle);
			hideTimeoutHandle = -1;
			if (showTimeoutHandle == -1) showTimeoutHandle = window.setTimeout(() => {
				showTooltip.value = true;
			}, props.timeoutShowMs);
		}
		if (navigator.maxTouchPoints == 0 || props.enableOnTouch) {
			watch(() => mousePos, handleElement, { deep: true });
			useIntervalTimer(handleElement, 500);
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "rootElem",
				ref: rootElem,
				class: "v-tooltip",
				style: normalizeStyle(dynamicStyle.value),
				innerHTML: tooltipText.value
			}, null, 12, _hoisted_1$2);
		};
	}
});
//#endregion
//#region src/util/helpTextRegistry.ts
/**
* A registry for context-sensitive help texts.
*
* Help texts are stored by ID and can be looked up by the ContextHelp component
* when a user clicks on an element with a `data-help` attribute.
*
* This module decouples help content from UI components, allowing texts to be
* defined centrally, loaded dynamically, or fetched from an API.
*/
var helpTexts = /* @__PURE__ */ new Map();
/**
* Register a help text entry.
* @param id - The help ID (matches the value of `data-help` attributes)
* @param content - The help text content (supports HTML)
*/
function registerHelpText(id, content) {
	helpTexts.set(id, content);
}
/**
* Retrieve a help text by ID.
* @param id - The help ID to look up
* @returns The help text content, or `undefined` if not found
*/
function getHelpText(id) {
	return helpTexts.get(id);
}
/**
* Check whether a help text ID exists in the registry.
* @param id - The help ID to check
* @returns `true` if a help text is registered for this ID
*/
function hasHelpText(id) {
	return helpTexts.has(id);
}
/**
* Remove a help text from the registry.
* @param id - The help ID to remove
*/
function removeHelpText(id) {
	helpTexts.delete(id);
}
/**
* Remove all registered help texts.
*/
function clearHelpTexts() {
	helpTexts.clear();
}
//#endregion
//#region src/components/contextHelp/contextHelp.ts
/** Reactive singleton that controls the global context help state. */
var contextHelp = reactive({
	/** Whether context help mode is currently active. */
	enabled: false,
	/** Toggle the context help mode on/off. */
	toggle() {
		this.enabled = !this.enabled;
	},
	/** Enable context help mode. */
	enable() {
		this.enabled = true;
	},
	/** Disable context help mode. */
	disable() {
		this.enabled = false;
	}
});
//#endregion
//#region src/components/contextHelp/ContextHelp.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$1 = ["innerHTML"];
//#endregion
//#region src/components/contextHelp/ContextHelp.vue
var ContextHelp_default = /* @__PURE__ */ defineComponent({
	__name: "ContextHelp",
	props: { dataPropName: { default: "data-help" } },
	setup(__props) {
		const props = __props;
		const showPopup = ref(false);
		const popupTitle = ref("Hilfe");
		const popupContent = ref("");
		/** Map from element to its cached data-help value, so we don't re-traverse the DOM on repeat clicks. */
		const helpCache = /* @__PURE__ */ new WeakMap();
		/**
		* Walk up the DOM tree from the clicked element to find a `data-help` attribute.
		* Uses a WeakMap cache to avoid repeated traversals of the same subtree.
		*/
		function findHelpId(element) {
			const cached = helpCache.get(element);
			if (cached !== void 0) return cached;
			let current = element;
			let result = null;
			while (current != null) {
				const helpId = current.getAttribute(props.dataPropName);
				if (helpId != null && helpId != "") {
					result = helpId;
					break;
				}
				current = current.parentElement;
			}
			helpCache.set(element, result);
			return result;
		}
		function onClick(evt) {
			if (!contextHelp.enabled) return;
			const target = evt.target;
			if (target == null) return;
			if (target.closest(".v-app-header-bar__context-help-button") != null) return;
			const helpId = findHelpId(target);
			if (helpId == null || !hasHelpText(helpId)) return;
			evt.preventDefault();
			evt.stopPropagation();
			deriveTitle(target);
			popupContent.value = getHelpText(helpId) ?? "";
			showPopup.value = true;
		}
		/**
		* Derive a meaningful popup title from the element's context.
		* Looks for the closest heading (h1-h6) in the element's ancestry,
		* or uses the element's own text content (truncated), or falls back to "Hilfe".
		*/
		function deriveTitle(element) {
			let current = element;
			while (current != null) {
				const tagName = current.tagName.toLowerCase();
				if ([
					"h1",
					"h2",
					"h3",
					"h4",
					"h5",
					"h6"
				].includes(tagName)) {
					popupTitle.value = current.textContent?.trim() ?? "Hilfe";
					return;
				}
				const heading = current.querySelector("h1, h2, h3, h4, h5, h6");
				if (heading != null) {
					popupTitle.value = heading.textContent?.trim() ?? "Hilfe";
					return;
				}
				current = current.parentElement;
			}
			const ownText = element.textContent?.trim();
			if (ownText != null && ownText.length > 0) {
				popupTitle.value = ownText.length > 60 ? ownText.substring(0, 57) + "…" : ownText;
				return;
			}
			popupTitle.value = "Hilfe";
		}
		function onPopupClose() {
			showPopup.value = false;
		}
		function setHelpModeActive(active) {
			if (active) document.body.classList.add("context-help-active");
			else document.body.classList.remove("context-help-active");
		}
		watch(() => contextHelp.enabled, (newval) => {
			setHelpModeActive(newval);
			if (!newval) showPopup.value = false;
		}, { immediate: true });
		useEventListener(document, "click", onClick, { capture: true });
		return (_ctx, _cache) => {
			return openBlock(), createBlock(Popup_default, {
				show: showPopup.value,
				"onUpdate:show": _cache[0] || (_cache[0] = ($event) => showPopup.value = $event),
				class: "x-right x-w-500",
				title: "Über das ausgewählte Element",
				"allow-outside-interaction": true,
				"close-on-outside-click": true,
				onClose: onPopupClose
			}, {
				default: withCtx(() => [createElementVNode("div", {
					class: "v-context-help__content",
					innerHTML: popupContent.value
				}, null, 8, _hoisted_1$1)]),
				_: 1
			}, 8, ["show"]);
		};
	}
});
//#endregion
//#region src/components/TreeNode.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1 = {
	key: 0,
	class: "v-tree-node__body"
};
var _hoisted_2 = {
	key: 1,
	class: "v-tree-node__children"
};
//#endregion
//#region src/components/TreeNode.vue
var TreeNode_default = /* @__PURE__ */ defineComponent({
	__name: "TreeNode",
	props: {
		cid: { default: "node_state" },
		filterFunc: {},
		matchOverride: { type: Boolean },
		showRoot: {
			type: Boolean,
			default: true
		},
		state: {},
		tree: {}
	},
	emits: ["update:state"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const manual_expand = ref(void 0);
		const expanded = computed(() => {
			if (props.tree.force_expanded || !props.showRoot) return true;
			return manual_expand.value || match_node_or_child.value;
		});
		const children = computed(() => {
			let result = Array();
			if (!props.tree) return result;
			if (!(props.tree?.children instanceof Array)) return result;
			const childless = [];
			for (const child of props.tree?.children) if (child.children instanceof Array && child.children.length > 0) result.push(child);
			else childless.push(child);
			result = result.concat(childless);
			return result;
		});
		const dynamicClass = computed(() => {
			return {
				"v-tree-node": true,
				"v-tree-node--rootless": !props.showRoot,
				"v-tree-node--collapsed": !expanded.value,
				"v-tree-node--filter-match": props.filterFunc != void 0 && match_node.value === true
			};
		});
		const match_node = computed(() => {
			return filter(props.tree, props.filterFunc, 0);
		});
		const match_node_or_child = computed(() => {
			return filter(props.tree, props.filterFunc, 1);
		});
		function filter(node, filterFunc, filterMode) {
			if (!(filterFunc instanceof Function)) return;
			if (!node) return;
			const result_node = filterFunc(node);
			if (filterMode == 0 || node.children?.length == 0) return result_node;
			if (result_node === void 0) return;
			let result_children = false;
			if (node.children instanceof Array) {
				for (const child of node.children) if (filter(child, filterFunc, filterMode) === true) {
					result_children = true;
					break;
				}
			}
			return result_node || result_children;
		}
		function toggle() {
			manual_expand.value = !manual_expand.value;
			if (props.cid && props.state) props.state[props.cid] = manual_expand.value;
		}
		if (props.state) {
			const nodeState = props.state[props.cid];
			if (nodeState != void 0) manual_expand.value = nodeState;
		} else emit("update:state", {});
		return (_ctx, _cache) => {
			const _component_TreeNode = resolveComponent("TreeNode", true);
			return match_node_or_child.value !== false || props.matchOverride ? (openBlock(), createElementBlock("div", {
				key: 0,
				class: normalizeClass(dynamicClass.value)
			}, [props.showRoot ? (openBlock(), createElementBlock("div", _hoisted_1, [renderSlot(_ctx.$slots, "body", {
				expanded: expanded.value,
				node: props.tree,
				toggle
			})])) : createCommentVNode("", true), children.value?.length > 0 && expanded.value || !props.showRoot ? (openBlock(), createElementBlock("div", _hoisted_2, [(openBlock(true), createElementBlock(Fragment, null, renderList(children.value, (child, index) => {
				return openBlock(), createBlock(_component_TreeNode, {
					state: props.state,
					"onUpdate:state": _cache[0] || (_cache[0] = ($event) => props.state = $event),
					cid: `${props.cid}-${index.toString()}`,
					tree: child,
					"filter-func": props.filterFunc,
					"match-override": match_node.value || props.matchOverride
				}, {
					body: withCtx(({ expanded, node, toggle }) => [renderSlot(_ctx.$slots, "body", {
						expanded,
						node,
						toggle
					})]),
					_: 3
				}, 8, [
					"state",
					"cid",
					"tree",
					"filter-func",
					"match-override"
				]);
			}), 256))])) : createCommentVNode("", true)], 2)) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/composables/useSortedArray.ts
/**
* Reactively orders an array by the return value of a value function.
* Automatically recomputes when the array, value function, or reverse flag changes.
*
* @param items - The array to order (plain value, ref, or getter).
* @param orderValueFunc - Function mapping each item to its sort key (plain function or ref holding a function).
* @param reverse - Getter returning true to sort in descending order.
*/
function useSortedArray(items, orderValueFunc, reverse = () => false) {
	return computed(() => {
		const arr = toValue(items) || [];
		const fn = unref(orderValueFunc);
		const rev = reverse();
		const sorted = [...arr].sort((a, b) => {
			const va = fn(a);
			const vb = fn(b);
			if (typeof va === "string" && typeof vb === "string") return va.localeCompare(vb);
			if (va < vb) return -1;
			if (va > vb) return 1;
			return 0;
		});
		return rev ? sorted.reverse() : sorted;
	});
}
//#endregion
//#region src/composables/useSmartFetch.ts
function useSmartFetch(url, options = {}) {
	const data = ref(null);
	const isLoading = ref(false);
	const error = ref(null);
	let controller = new AbortController();
	const maxRetries = options.maxRetries ?? 3;
	const retryDelay_ms = options.retryDelay_ms ?? 500;
	const retryOnStatus = options.retryOnStatus ?? [];
	const waitForRetry = (attempt, signal) => new Promise((resolve, reject) => {
		if (signal.aborted) {
			reject(Object.assign(/* @__PURE__ */ new Error("AbortError"), { name: "AbortError" }));
			return;
		}
		const onAbort = () => {
			clearTimeout(retryTimeout);
			reject(Object.assign(/* @__PURE__ */ new Error("AbortError"), { name: "AbortError" }));
		};
		const retryTimeout = setTimeout(() => {
			signal.removeEventListener("abort", onAbort);
			resolve();
		}, retryDelay_ms * Math.pow(2, attempt));
		signal.addEventListener("abort", onAbort, { once: true });
	});
	const attemptFetch = async (attempt) => {
		controller = new AbortController();
		try {
			const response = await fetch(toValue(url), {
				signal: controller.signal,
				headers: options.headers
			});
			if (!response.ok) {
				if (retryOnStatus.includes(response.status) && attempt < maxRetries) {
					console.warn(`useFetch: HTTP ${response.status} on attempt ${attempt + 1}/${maxRetries + 1}. Retrying in ${retryDelay_ms * Math.pow(2, attempt)}ms.`);
					await waitForRetry(attempt, controller.signal);
					return attemptFetch(attempt + 1);
				}
				isLoading.value = false;
				data.value = null;
				error.value = {
					message: `HTTP error ${response.status}: ${response.statusText}`,
					status: response.status
				};
				return;
			}
			const body = await response.text();
			isLoading.value = false;
			error.value = null;
			let parsed = body;
			const contentType = response.headers.get("content-type") || "";
			if (contentType.includes("application/json") || contentType.endsWith("+json")) try {
				parsed = JSON.parse(body);
			} catch (e) {
				error.value = {
					message: "Error parsing JSON response.",
					status: response.status,
					originalError: e
				};
				console.warn("useFetch: Error parsing JSON response. Returning original body.", e);
			}
			if (typeof options.parseCallback == "function") try {
				parsed = options.parseCallback(parsed);
			} catch (e) {
				error.value = {
					message: "Error in response parse callback function.",
					originalError: e
				};
				console.warn("useFetch: Error in parseCallback. Returning unparsed body.", e);
			}
			data.value = parsed;
		} catch (e) {
			if (e.name === "AbortError") return;
			if (attempt < maxRetries) {
				console.warn(`useFetch: Fetch error on attempt ${attempt + 1}/${maxRetries + 1}. Retrying in ${retryDelay_ms * Math.pow(2, attempt)}ms.`, e);
				try {
					await waitForRetry(attempt, controller.signal);
				} catch (retryErr) {
					if (retryErr.name === "AbortError") return;
					throw retryErr;
				}
				return attemptFetch(attempt + 1);
			}
			isLoading.value = false;
			data.value = null;
			error.value = {
				message: "Unspecified error occurred during fetch attempt.",
				originalError: e
			};
			console.error("useFetch: Fetch error occurred.", e);
		}
	};
	const handler = async () => {
		controller.abort();
		if (!toValue(url)) {
			data.value = null;
			isLoading.value = false;
			error.value = { message: "URL is empty or invalid." };
			return;
		}
		isLoading.value = true;
		error.value = null;
		await attemptFetch(0);
	};
	const handler_debounced = debounce(handler, options.debounceTime_ms ?? 100);
	watch(() => toValue(url), handler_debounced, { immediate: !options.lazy });
	onUnmounted(() => {
		controller.abort();
	});
	return {
		data,
		isLoading,
		error,
		refresh: handler_debounced
	};
}
//#endregion
//#region src/composables/useDelayedBoolean.ts
function useDelayedBoolean(watchedValue, delayOnTrue_ms, delayOnFalse_ms) {
	const result = ref(watchedValue.value);
	let timeout = -1;
	watch(watchedValue, (newValue) => {
		if (timeout !== -1) window.clearTimeout(timeout);
		const delay = newValue ? delayOnTrue_ms : delayOnFalse_ms;
		timeout = window.setTimeout(() => {
			result.value = newValue;
			timeout = -1;
		}, delay);
	});
	return result;
}
//#endregion
//#region src/util/ColorRGBA.ts
var ColorRGBA = class ColorRGBA {
	constructor(values = void 0) {
		_defineProperty(this, "values", [
			0,
			0,
			0,
			255
		]);
		if (values instanceof Array) for (let ii = 0; ii < Math.min(values.length, 5); ii++) this.values[ii] = values[ii];
		else if (typeof values == "string") {
			if (values.charAt(0) == "#") values = values.substring(1);
			if (values.length == 3) values = values.charAt(0) + values.charAt(0) + values.charAt(1) + values.charAt(1) + values.charAt(2) + values.charAt(2);
			const r = parseInt(values.substring(0, 2), 16);
			const g = parseInt(values.substring(2, 4), 16);
			const b = parseInt(values.substring(4, 6), 16);
			let a = 255;
			if (values.length == 8) a = parseInt(values.substring(6, 8), 16);
			this.values = [
				r,
				g,
				b,
				a
			];
		}
	}
	get r() {
		return this.values[0];
	}
	get g() {
		return this.values[1];
	}
	get b() {
		return this.values[2];
	}
	get a() {
		return this.values[3];
	}
	set r(newval) {
		this.values[0] = newval;
	}
	set g(newval) {
		this.values[1] = newval;
	}
	set b(newval) {
		this.values[2] = newval;
	}
	set a(newval) {
		this.values[3] = newval;
	}
	add(other) {
		const result = new ColorRGBA();
		for (let ii = 0; ii < 4; ii++) result.values[ii] = this.values[ii] + other.values[ii];
		return result;
	}
	changeBrightnessByPercent(percent) {
		const result = this.copy();
		for (let ii = 0; ii < 4; ii++) result.values[ii] = Math.min(255, result.values[ii] * ((100 + percent) / 100));
		return result;
	}
	copy() {
		return new ColorRGBA(this.values.slice());
	}
	mult(factor) {
		const result = new ColorRGBA();
		for (let ii = 0; ii < 5; ii++) result.values[ii] = this.values[ii] * factor;
		return result;
	}
	round() {
		const result = new ColorRGBA();
		for (let ii = 0; ii < 5; ii++) result.values[ii] = Math.round(this.values[ii]);
		return result;
	}
	sub(other) {
		const result = new ColorRGBA();
		for (let ii = 0; ii < 5; ii++) result.values[ii] = this.values[ii] - other.values[ii];
		return result;
	}
	decimalToHex(rgb) {
		let hex = Number(rgb).toString(16);
		if (hex.length < 2) hex = "0" + hex;
		return hex;
	}
	toHexString(alpha = true) {
		const rounded = this.round();
		let result = "#" + this.decimalToHex(rounded.r) + this.decimalToHex(rounded.g) + this.decimalToHex(rounded.b);
		if (alpha) result += this.decimalToHex(rounded.a);
		return result;
	}
	toRgbaString() {
		return "rgba(" + this.r + "," + this.g + "," + this.b + "," + this.a + ")";
	}
};
//#endregion
//#region src/util/colorUtils.ts
function makeColorRampArray(colorStart, colorEnd, numSteps) {
	const colStart = new ColorRGBA(colorStart);
	const colorDiff = new ColorRGBA(colorEnd).sub(colStart);
	const colors = Array();
	for (let index = 0; index < numSteps; index++) {
		let step = 0;
		if (numSteps > 1) step = index / (numSteps - 1);
		colors.push(colStart.add(colorDiff.mult(step)).round().toHexString());
	}
	return colors;
}
//#endregion
//#region src/util/formatters.ts
function formatNumber(value, options = {}) {
	if (value === null || value === void 0) return "";
	if (isNaN(value)) return "";
	const numDecimals = options.numDecimals || 0;
	const decimalSeparator = options.decimalSeparator || ",";
	const thousandsSeparator = options.thousandsSeparator || ".";
	const unit = options.unit || "";
	const addSign = options.addSign || false;
	const shortThreshold = options.shortThreshold || Infinity;
	let shortChar = "";
	let shortValue = value;
	if (shortThreshold) {
		if (shortThreshold <= 1e3 && shortValue >= 1e3) {
			shortValue = value / 1e3;
			shortChar = "&nbsp;Tsd";
		}
		if (shortThreshold <= 1e6 && value >= 1e6) {
			shortValue = value / 1e6;
			shortChar = "&nbsp;Mio";
		}
	}
	value = shortValue;
	const factor = Math.pow(10, numDecimals);
	const piece = (Math.round(value * factor) / factor).toString();
	let parts = [piece];
	if (piece.includes(".")) parts = piece.split(".");
	let result = "";
	if (value > 0 && addSign) result += "+";
	result += parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
	if (numDecimals > 0) {
		let decimalsString = "";
		if (parts.length > 1) decimalsString = parts[1].substring(0, numDecimals);
		result += decimalSeparator;
		result += decimalsString.padEnd(numDecimals, "0");
	}
	result += shortChar;
	if (unit != "") result += " " + unit;
	return result;
}
//#endregion
export { AbstractMapModule, Collapsible_default as Collapsible, ColorRGBA, Combobox_default as Combobox, ContextHelp_default as ContextHelp, ContextMenu_default as ContextMenu, DashboardPanel_default as DashboardPanel, DualView_default as DualView, HeadlessList_default as HeadlessList, HighlightText_default as HighlightText, Legend_default as Legend, List_default as List, LoadingIndicatorOverlay_default as LoadingIndicatorOverlay, MapLibreMap_default as MapLibreMap, PaginationControl_default as PaginationControl, Popup_default as Popup, ProgressBar_default as ProgressBar, PropertyGrid_default as PropertyGrid, ScrollSensor_default as ScrollSensor, ScrollSensorItem_default as ScrollSensorItem, ScrollSensorMenu_default as ScrollSensorMenu, SelectMode, SmartButton_default as SmartButton, SmartRangeInput_default as SmartRangeInput, SmartSelect_default as SmartSelect, SmartTable_default as SmartTable, SmartTextInput_default as SmartTextInput, Spinner_default as Spinner, SplitPanel_default as SplitPanel, SvgColorGradient_default as SvgColorGradient, Tab_default as Tab, TabsGroup_default as TabsGroup, TimePointSelector_default as TimePointSelector, TimeRangeSelector_default as TimeRangeSelector, Tooltip_default as Tooltip, TreeNode_default as TreeNode, ViewStack_default as ViewStack, ViewStackController, clamp, clearHelpTexts, contextHelp, contextMenu, debounce, formatNumber, getHelpText, hasHelpText, makeArray, makeColorRampArray, normalizeRange, registerHelpText, removeHelpText, roundToDigits, sortYears, ticksForRange, ticksForYears, useDelayedBoolean, useDragPosition, useElementSize, useOnElementResize, useOnOutsideClick, useSmartFetch, useSortedArray, useViewportSize, xToYear, yearToX };

//# sourceMappingURL=gertrud.js.map